/** COTELE PLANȘEI — unde se scriu și care se tac.
 *
 *  CE E O COTĂ AICI. O linie subțire de tuș, paralelă cu fața unui zid, cu o
 *  bulină la fiecare capăt și cu cifra care ÎNTRERUPE linia la mijloc — desenul
 *  de pe planșele de referință (Stay House, MF Architecture). Nu e un text pus
 *  lângă un perete: e o măsură cu capete, deci se vede DE UNDE PÂNĂ UNDE.
 *
 *  FIECARE FAȚĂ DE ZID A FIECĂREI CAMERE îți spune cât are, ÎN camera ei.
 *  Camerele sunt derivate din pereți (`editor/camere.ts`), deci laturile
 *  inelului unei camere sunt chiar fețele zidurilor din jurul ei, tăiate la
 *  colțuri — o ușă nu rupe fața, fiindcă derivarea astupă golurile. Pe
 *  deasupra, conturul modulului primește cotele lui de ansamblu, în afară.
 *
 *  CE FACE PLANȘA CITIBILĂ — regulile, în ordinea în care se aplică:
 *
 *    1. **Corpul literei e ÎN PIXELI, nu în metri.** O cotă e o adnotare, ca
 *       într-un CAD: la orice mărire are 12 px. De-aici vine tot restul —
 *       când te depărtezi, cifrele nu se micșorează până la ilizibil, ci
 *       DISPAR acolo unde nu mai încap, și se întorc când te apropii.
 *    2. **O cotă se scrie doar dacă încape pe latura ei**: lungimea laturii pe
 *       ecran trebuie să acopere cifra, o pernă de fiecare parte și cele două
 *       buline. La 37 px/m (tot modulul pe ecran) o latură de 1,10 m are 40 px
 *       și tace; la 80 px/m vorbește. Asta lasă întotdeauna vizibile laturile
 *       mari — cele pentru care se deschide planul — și le dezvăluie pe cele
 *       mici la mărirea la care chiar se lucrează pe ele.
 *    3. **Nimic nu se scrie peste altceva.** Numele și ariile camerelor se
 *       așază întâi; apoi cotele, de la cea mai lungă latură la cea mai
 *       scurtă, și fiecare se pune numai dacă dreptunghiul cifrei ei nu atinge
 *       nimic pus deja. Pe o cameră îngustă, cotele celor două fețe lungi ar
 *       cădea una peste alta: a doua tace. Pe una mică, cota ar cădea peste
 *       nume: cota tace, numele rămâne — o cameră fără nume nu se recunoaște,
 *       una fără cotă se măsoară de pe vecine.
 *    4. **O cameră în care cota n-ar avea loc nu primește niciuna**: latura ei
 *       mică pe ecran trebuie să fie mai mare decât depărtarea cotei de zid
 *       plus corpul literei, altfel cifra ar sta pe zidul din față.
 *    5. **O MĂSURĂ SE SCRIE O SINGURĂ DATĂ.** Două fețe care spun același
 *       număr despre același loc din plan sunt o cotă și un ecou — iar ecoul
 *       nu adaugă nimic, doar îndeasă planșa și pune cititorul să se întrebe
 *       ce deosebire n-a văzut. Două fețe spun același lucru când sunt
 *       paralele, la fel de lungi până la zecimalele scrise, și se suprapun
 *       aproape tot (`puntea`). Asta prinde, cu aceeași socoteală, toate
 *       formele în care se năștea dublura:
 *         * fețele opuse ale unei camere — nu doar ale dreptunghiului:
 *           coridorul în L își scria lungimea pe amândouă zidurile lungi;
 *         * laturile opuse ale conturului — «15,30» în stânga și «15,30» în
 *           dreapta modulului;
 *         * **cele două fețe ale unui zid**, una în fiecare cameră de alături:
 *           același zid, aceeași lungime, cifrele la 30 cm una de alta.
 *       Primele două sunt fețe ale ACELUIAȘI inel, deci se împerechează pe loc
 *       (`perechileInelului`). A treia e între inele diferite, și se
 *       recunoaște uitându-te CÂT E ÎNTRE fețe: puntea dintre ele nu trebuie
 *       să fie mai lungă decât un zid — fie e chiar aceeași linie, fie e
 *       grosimea peretelui dintre camere. Cât e «un zid» se MĂSOARĂ pe plan
 *       (`unZidIntre`), nu se scrie aici: pe o planșă cu fațadă de 45 cm
 *       înseamnă 45 cm, pe una numai cu compartimentări înseamnă 10.
 *    6. **Din două fețe care spun la fel se păstrează cea mai LIBERĂ** — cea
 *       peste care cad mai puține piese de mobilier și mai puține uși —,
 *       fiindcă o linie de cotă care traversează un dulap sau baleiajul unei
 *       uși nu se mai citește nici ea, nici desenul de sub ea. Aglomerarea se
 *       măsoară în fâșia dintre fața zidului și linia cotei (`BANDA_M`), la
 *       fiecare așezare a planșei: muți patul sau întorci ușa, cota trece pe
 *       fața cealaltă. Alegerea asta e doar FAVORITA: la urmă se așază
 *       amândouă fețele cu adevărat (`asezarea`) și se scrie cea care iese mai
 *       ieftin, fiindcă abia acolo se vede dacă cifra chiar încape și peste ce
 *       cade. Dacă însă măsura e DEJA SCRISĂ dincolo de zid, nu se mai încearcă
 *       nimic: ar aduce înapoi exact cifra care tocmai s-a tăiat.
 *    7. **CÂND SE POATE, COTELE STAU PE ACEEAȘI LINIE.** Două măsuri paralele
 *       desenate la 4 px una de alta nu sunt două linii, sunt o linie strâmbă:
 *       ochiul le vede ca pe o greșeală de desen înainte să le citească.
 *       Depărtarea unei cote de zidul ei nu e însă o mărime sfântă — e doar
 *       locul unde se vede bine —, deci o cotă nouă încearcă întâi să se așeze
 *       CHIAR pe o linie desenată deja (`liniaPrin`, `linii`). Laturile mari se
 *       scriu primele, deci ele trag liniile, iar cele mici se agață de ele.
 *    8. **NICIO CIFRĂ PESTE UN ZID, și cât mai puține peste mobilă.** Un număr
 *       scris peste hașura unui perete nu se citește nici el, nici hașura; unul
 *       peste parapetul unui balcon sau peste un vas de closet e aproape la fel
 *       de rău. De-aia linia are voie să se dea puțin mai încolo
 *       (`DEPARTARE_PX`), iar dacă nici asta n-ajunge — canapeaua ține toată
 *       fațada, cada ține toată baia — CIFRA ALUNECĂ pe propria linie până iese
 *       la lumină (`Cota::la`), cum face textul oricărei cote de CAD. Linia se
 *       rupe acolo unde ajunge ea, deci măsura rămâne întreagă și cu bulinele
 *       la locul lor. Zidurile intră în socoteală cu POLIGONUL lor, nu cu cutia
 *       din jur: un parapet în U ține tot balconul în cutie și e gol pe
 *       dinăuntru (v. `atingePoligonul`).
 *    9. **Nimic nu e interzis, totul e cântărit.** Regulile 7 și 8 nu sunt
 *       opriri, ci prețuri (`costul`): un zid sub cifră costă mai mult decât o
 *       piesă de mobilier, o piesă costă mai mult decât o linie nealiniată, iar
 *       la preț egal câștigă depărtarea firească și cifra la mijloc. O cameră
 *       în care ORICE așezare dă peste ceva își primește totuși cota, pe cea
 *       mai puțin rea — o cameră necotată e mai rău decât una cotată peste un
 *       dulap.
 *   10. **FIECARE UȘĂ ÎȘI SCRIE GOLUL**, «0,90/2,10», nu doar cea aleasă.
 *       Lățimea pe înălțime e măsura după care se comandă tâmplăria și se
 *       lasă spărtura în zid, iar înălțimea e chiar ce un plan — o secțiune
 *       orizontală pe la un metru — n-are cum să arate altfel. Așezarea ei o
 *       face `cotaUsii`: pe golul ei, în partea în care nu baleiază foaia.
 *       Regula 2 nu i se aplică așa cum e scrisă, fiindcă o ușă de 0,90 m
 *       n-ar purta niciodată două cifre între bulinele ei: golul e desenat ca
 *       o întrerupere a zidului, deci se vede DE UNDE PÂNĂ UNDE fără linie,
 *       iar cifra stă peste el pe perna ei de hârtie. În locul ei, pragul e
 *       că numărul n-are voie să se întindă peste mai mult de o dată și
 *       jumătate golul ei (`INTINDEREA_GOLULUI`): mai lat de-atât nu mai e
 *       măsura ușii ăleia, e un text culcat peste plan.
 *       Regula 3 rămâne întreagă, și ușile se așază ÎNAINTEA camerelor: ele
 *       n-au de ales locul, pe când cota unei camere alunecă pe linia ei sau
 *       se dă mai încolo (regulile 7 și 8).
 *
 *  Regulile sunt GEOMETRIE, nu o listă de excepții: aceeași socoteală pe M1
 *  cu 11 camere și pe M5 cu 21, la orice mărire. Nu există «prea multe cote»
 *  — există cote care nu încap sau care repetă, și alea nu se desenează.
 *
 *  COTELE OBIECTULUI ALES (`coteleObiectului`) sunt alt lucru: distanța de la
 *  el la PRIMUL obstacol în fiecare din cele patru direcții, cât timp e ales
 *  sau tras. Sunt măsuri de lucru, nu ale planșei, deci se desenează în
 *  culoarea selecției și dispar cu ea. Regula 5 e și a lor: aceeași distanță
 *  pe aceeași parte se scrie o dată.
 *
 *  ORICE OBIECT, nu doar o piesă de mobilier. A fost o vreme numai a mobilei,
 *  și de-acolo venea întrebarea: de ce dulapul își spune cât e până la zid, iar
 *  ZIDUL nu spune nimic? Măsura nu e o însușire a mobilei — e răspunsul la
 *  «unde stă ăsta față de ce e în jur», iar întrebarea se pune la fel despre un
 *  perete, o ușă, o priză sau o bucată de nucleu. Deci socoteala e una singură
 *  și lucrează pe CUTIA obiectului, oricare ar fi el (v. `cutiaAlesului`).
 *
 *  ȘI SE POT SCRIE. O cotă de lucru poartă cu ea axa și sensul pe care le-a
 *  măsurat (`Cota::muta`), iar cu ele cifra se poate TASTA: scrii 0,80 în locul
 *  lui 1,23, iar obiectul pleacă exact atât cât să lase golul cerut. Cine
 *  desenează un plan are în cap «ușa la 15 cm de colț», nu «ușa mutată cu 8 cm»
 *  — deci cifra care se citește trebuie să fie și cifra care se scrie.
 */
import { inInel, type Camera, type Gol, type Perete, type PlanTronson,
         type Pt } from "./doc";
import type { Ales } from "./Desen";
import { familiileDozei, type FamilieDoza } from "./design/electric";
import { cutiileEtichetelorH, grupeleDozelor, intindereaDozei }
  from "./design/ElectricDesen";

/** O cotă gata de desenat: capetele liniei (deja depărtate de zid), lungimea
 *  măsurată și — pentru cele de lucru — pe ce axă și în ce sens s-a măsurat. */
export type Cota = {
  a: Pt;
  b: Pt;
  /** CE MĂSOARĂ cota, înainte de împinsul afară: fața de zid, golul ușii.
   *  Pe ea se ține identitatea cotei (v. `cheiaCotei`), fiindcă `a`/`b` se
   *  mută cu mărirea — depărtarea liniei e în pixeli, nu în metri. */
  masurat?: [Pt, Pt];
  /** A pus-o OMUL, de la un punct la altul (v. `doc::CotaDoc`). Cele fără
   *  semnul ăsta sunt socotite din geometrie la fiecare desenare. */
  deMana?: boolean;
  /** Ce se scrie: lungimea, în metri. Formatarea o face desenul (limba). */
  valoare: number;
  /** A DOUA CIFRĂ, scrisă după bară. O cotă spune de obicei o măsură; cea a
   *  unei uși spune două — «1,03/2,10», lățimea pe înălțime, cum se scrie pe
   *  orice planșă —, fiindcă înălțimea e chiar ce desenul în plan n-are cum
   *  să arate. `valoare` rămâne lungimea DESENATĂ, ca linia și golul din ea
   *  să se socotească la fel ca la celelalte; formatarea o face tot desenul. */
  si?: number;
  /** UNDE STĂ CIFRA PE LINIA EI, ca fracțiune din `a`→`b`. Lipsă înseamnă la
   *  mijloc, și așa e aproape întotdeauna: mijlocul e locul firesc al cifrei,
   *  iar o planșă în care fiecare număr stă în altă parte se citește greu.
   *
   *  Se abate de-acolo doar când la mijloc ar cădea peste ceva — un vas de
   *  closet, o canapea lipită de fațadă — și nicio depărtare de zid nu scapă de
   *  el: atunci cifra alunecă de-a lungul propriei linii până iese la lumină,
   *  cum face textul oricărei cote de CAD. Linia se rupe acolo unde ajunge ea,
   *  deci măsura rămâne întreagă și cu bulinele la locul lor. */
  la?: number;
  /** Where the figure stands off its line, in metres, when its span is too
   *  short to carry it and the neighbouring figures: the line stays whole. */
  deplasare?: Pt;
  /** CUM SE SCRIE CIFRA: axa pe care s-a măsurat golul și sensul în care se
   *  duce de la obiect spre obstacol (+1 = spre valori mai mari).
   *
   *  Cu ele, o valoare tastată devine o deplasare: `semn × (măsurat − scris)`
   *  duce obiectul exact până acolo. Lipsă la cotele PLANȘEI — alea măsoară
   *  fețe de zid, iar o față nu se mută singură de la cealaltă. */
  muta?: { axa: 0 | 1; semn: 1 | -1 };
  /** PE CE ZID SE SCRIE CIFRA, când obiectul ales nu e el însuși cel care se
   *  mută. Cotele unei CAMERE măsoară lumina dintre pereții ei: scrisă altfel,
   *  cifra ar fi mutat camera, care nu e un obiect ce se mută — ea e golul
   *  dintre ziduri. `punct` e locul de pe zid pe care «pune mâna» mutarea,
   *  adică ce spune `imparteZidulLaCamera` despre care cameră e vorba. */
  peZid?: { i: number; punct: Pt };
  /** COTĂ DE AȘEZARE A UNUI GOL ALES — v. `coteleAsezariiGolului`.
   *
   *  Ea nu e o cotă a PLANȘEI: se naște din selecție și piere cu ea. De-aia
   *  n-are «×»: stinsul se ține pe cheie, în `dims_stinse`, iar o cheie scrisă
   *  pentru ea n-ar stinge nimic — cota se face din nou la următoarea alegere —
   *  și ar murdări documentul cu o intrare fără rost. */
  asezare?: boolean;
  /** A CĂREI UȘI E MĂSURA — indicele golului (`Gol::idx`), pe cotele puse de
   *  regula 10. Cu el desenul recunoaște cota ușii ALESE printre cele ale
   *  planșei și o scrie în culoarea selecției, în loc s-o mai deseneze o dată
   *  peste ea. */
  usa?: number;
  /** MĂSURA UNEI ARCADE — golul dintre două ziduri colineare
   *  (`golurileDintreZiduri`). Ca `usa`, spune că cifra e a unui GOL din zid,
   *  nu a unei fețe de cameră: o arcadă de 1,60 m într-un hol cu o latură de
   *  1,60 m nu e un ecou, sunt două măsuri diferite. Deosebirea se face aici,
   *  pe cotă, fiindcă o arcadă n-are indice de gol în document — ea nu e
   *  scrisă nicăieri, se DEDUCE din cele două ziduri. */
  arcada?: boolean;
  /** CORPUL CIFREI, în pixeli, când nu e cel obișnuit (`COTA_PX.corp`). Măsura
   *  unei uși se scrie mai mic decât cotele de pereți: ea e o adnotare pe un
   *  obiect de 90 cm, nu un lanț de cote al planșei, iar scrisă la fel de mare
   *  s-ar întinde peste jumătate de cameră și ar tăcea tocmai la mărirea la
   *  care se deschide modulul. */
  corp?: number;
};

/** Un dreptunghi ocupat de scris, în metri — cu el se apără de suprapuneri. */
export type Cutie = { x0: number; y0: number; x1: number; y1: number };

/** Mărimile adnotării, ÎN PIXELI. Aceleași la orice mărire — v. regula 1. */
export const COTA_PX = {
  /** Corpul cifrei. Numele camerei e cu două puncte mai mare (el e reperul
   *  după care se recunoaște încăperea), iar aria ei se scrie chiar cu corpul
   *  ăsta — v. `ETICHETA_PX` și `ARIE_RAPORT` din `Desen.tsx`. */
  corp: 12,
  /** Depărtarea liniei de cotă de fața zidului, înăuntrul camerei. */
  inauntru: 16,
  /** Depărtarea cotelor de ansamblu de conturul modulului, în afară. */
  afara: 20,
  /** Corpul cifrei unei uși — v. `Cota::corp`. */
  corpGol: 10,
  /** Depărtarea cotei unui gol de fața zidului în care stă — v. regula 10.
   *  Mai mică decât a cotelor de cameră: măsura ușii e a ușii, deci stă lipită
   *  de ea, nu pe rândul cotelor de perete. */
  gol: 10,
  /** Perna dintre cifră și linia pe care o întrerupe, de fiecare parte. */
  perna: 5,
  /** Raza bulinei de capăt. */
  bulina: 1.7,
} as const;

/** Lățimea unei cifre scrise cu corpul dat — cifrele unei sans stau la cam
 *  0,58 din corp, iar virgula la jumătate. Aproximare pentru așezare, nu
 *  măsurătoare de font: perna acoperă diferența. */
export function latimeaCifrei(text: string, corp: number): number {
  let l = 0;
  for (const ch of text) l += ch === "." || ch === "," ? 0.3 : 0.58;
  return l * corp;
}

/** Un număr cu două zecimale, cum se scrie pe cotă — pentru măsurat lățimea,
 *  nu pentru afișat: afișarea trece prin limbă (`i18n.numar`), iar punctul și
 *  virgula au aceeași lățime. */
const textul = (v: number) => v.toFixed(2);

/** Ce scrie o cotă, ca text — o cifră, sau două despărțite de bară când cota
 *  poartă și `si` (v. `Cota::si`). Tot pentru măsurat lățimea, nu pentru
 *  afișat: desenul îl reface prin limbă, cu aceleași lățimi de caractere. */
const textulCotei = (c: { valoare: number; si?: number }) =>
  c.si != null ? `${textul(c.valoare)}/${textul(c.si)}` : textul(c.valoare);

const seAting = (a: Cutie, b: Cutie) =>
  a.x0 < b.x1 && b.x0 < a.x1 && a.y0 < b.y1 && b.y0 < a.y1;

/** INELUL FĂRĂ VÂRFURILE DE PE LATURI. Derivarea din pereți lasă vârfuri la
 *  mijlocul unei fețe — acolo unde un zid vecin se oprește în ea. O cotă pe
 *  fiecare bucată ar scrie «1,25» și «2,20» în loc de «3,45», adică ar cota
 *  zidurile de alături, nu fața asta. */
export function faraColinear(ring: readonly Pt[], tol = 1e-4): Pt[] {
  // întâi dublurile
  const p: Pt[] = [];
  for (const q of ring) {
    const u = p[p.length - 1];
    if (!u || Math.hypot(q[0] - u[0], q[1] - u[1]) > tol) p.push(q);
  }
  while (p.length > 1 && Math.hypot(p[0][0] - p[p.length - 1][0],
                                   p[0][1] - p[p.length - 1][1]) <= tol) {
    p.pop();
  }
  if (p.length < 3) return p;
  const out: Pt[] = [];
  for (let i = 0; i < p.length; i++) {
    const a = p[(i + p.length - 1) % p.length];
    const b = p[i];
    const c = p[(i + 1) % p.length];
    const cr = (b[0] - a[0]) * (c[1] - b[1]) - (b[1] - a[1]) * (c[0] - b[0]);
    const l1 = Math.hypot(b[0] - a[0], b[1] - a[1]);
    const l2 = Math.hypot(c[0] - b[0], c[1] - b[1]);
    // sinusul unghiului dintre laturi; sub o miime, e o linie
    if (l1 > 0 && l2 > 0 && Math.abs(cr) / (l1 * l2) < 1e-3) continue;
    out.push(b);
  }
  return out;
}

/** Normala UNITARĂ a laturii `a→b` care intră în inel. Se verifică pe inel,
 *  nu se deduce din orientare: inelele derivate n-au un sens garantat. */
function normalaInauntru(a: Pt, b: Pt, ring: readonly Pt[]): Pt {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const L = Math.hypot(dx, dy) || 1;
  const n: Pt = [-dy / L, dx / L];
  const m: Pt = [(a[0] + b[0]) / 2 + n[0] * 0.02, (a[1] + b[1]) / 2 + n[1] * 0.02];
  return inInel(m, ring) ? n : [-n[0], -n[1]];
}

/** Where a cote's figure is drawn, on its line or off it. */
export function punctulCifrei(c: Cota): Pt {
  const t = c.la ?? 0.5;
  return [c.a[0] + (c.b[0] - c.a[0]) * t + (c.deplasare?.[0] ?? 0),
          c.a[1] + (c.b[1] - c.a[1]) * t + (c.deplasare?.[1] ?? 0)];
}

/** Dreptunghiul de încadrare al cifrei unei cote, în metri. Pentru o latură
 *  oblică se ia cutia axială a textului rotit — mai mare decât textul, deci
 *  păzește mai mult decât trebuie, ceea ce e partea bună a greșelii.
 *
 *  `perna` e ce se lasă liber în jurul cifrei, de fiecare parte. Implicit e
 *  perna cotei, cu care se ține scrisul la distanță de alt scris; cu ZERO
 *  iese cutia TUȘULUI, atât cât chiar acoperă cifra. Deosebirea contează la
 *  uși: numărul unei uși e mai lung decât golul ei, deci cu perna cu tot
 *  ajunge cu două-trei centimetri în zidul perpendicular de la colț — hârtie
 *  albă peste hașură, nu cifră peste hașură. */
export function cutiaCifrei(c: Cota, k: number,
                            perna: number = COTA_PX.perna): Cutie {
  const [mx, my] = punctulCifrei(c);
  const corp = c.corp ?? COTA_PX.corp;
  const w = (latimeaCifrei(textulCotei(c), corp) + 2 * perna) / k;
  const h = (corp * 1.2) / k;
  const dx = c.b[0] - c.a[0];
  const dy = c.b[1] - c.a[1];
  const L = Math.hypot(dx, dy) || 1;
  const ux = Math.abs(dx / L);
  const uy = Math.abs(dy / L);
  // proiecția cutiei rotite pe axe
  const bw = w * ux + h * uy;
  const bh = w * uy + h * ux;
  return { x0: mx - bw / 2, y0: my - bh / 2, x1: mx + bw / 2, y1: my + bh / 2 };
}

/** Cât trebuie să aibă o latură PE ECRAN ca cifra ei să încapă: cifra, cele
 *  două perne, cele două buline și încă puțin din linie de fiecare parte, ca
 *  să se vadă că E o linie întreruptă, nu doar o cifră. */
export function lungimeaMinima(valoare: number): number {
  return latimeaCifrei(textul(valoare), COTA_PX.corp) + 2 * COTA_PX.perna
    + 4 * COTA_PX.bulina + 10;
}

/** TREPTELE DEPĂRTĂRII UNEI COTE DE GOL de fața zidului, în pixeli: cea
 *  firească, și două mai depărtate pentru când acolo cifra ar cădea peste ceva
 *  scris deja. Mai multe n-au rost — o măsură a ușii dusă la o palmă de ea nu
 *  mai e a ușii. */
const DEPARTARI_GOL = [COTA_PX.gol, COTA_PX.gol + 8, COTA_PX.gol + 16];

/** …IAR O ARCADĂ POATE MERGE MAI DEPARTE, până la o palmă de zid.
 *
 *  O ușă are multe surori pe aceeași planșă: cifra ei dusă departe n-ar mai
 *  spune a cui e, de-aia se oprește la a treia treaptă și, dacă nici acolo nu
 *  încape, TACE — măsura ei se citește oricum din panou.
 *
 *  O ARCADĂ N-ARE DE UNDE SE CITI ALTFEL: ea nu e scrisă nicăieri în document,
 *  se deduce din două ziduri (v. `golurileDintreZiduri`), deci o cotă care tace
 *  e singura cifră a golului pierdută cu totul. Măsurat pe planul real: o
 *  spărtură de 0,80 m făcută în mijlocul modulului cădea între cotele camerelor
 *  din jur și nu încăpea la niciuna din cele trei trepte — omul rupea zidul și
 *  nu vedea NICIO cifră. Mai bine puțin mai departe decât deloc. */
const DEPARTARI_ARCADA = [...DEPARTARI_GOL,
                          COTA_PX.gol + 26, COTA_PX.gol + 36, COTA_PX.gol + 48];

/** CÂT SE POATE ÎNTINDE NUMĂRUL UNEI UȘI peste golul ei, ca raport — regula
 *  10. «0,90/2,10» are 56 px, un gol de 0,90 m are 54 px la mărirea de lucru:
 *  numărul iese oricum peste tocuri, și așa se scrie pe orice planșă. Dar peste
 *  o jumătate de gol de fiecare parte nu mai e măsura ușii ăleia, e un text
 *  culcat peste plan — deci de-acolo în jos tace, cum tac și laturile mici
 *  (regula 2). Cu corpul ei mai mic (`COTA_PX.corpGol`), cifra unei uși de
 *  0,90 m se scrie de la 35 px/m în sus — adică de la mărirea la care modulul
 *  întreg intră pe ecran. */
const INTINDEREA_GOLULUI = 1.5;

/** O cotă pe latura `a→b`, depărtată cu `ofs` metri pe normala `n`. */
const cota = (a: Pt, b: Pt, n: Pt, ofs: number): Cota => ({
  a: [a[0] + n[0] * ofs, a[1] + n[1] * ofs],
  b: [b[0] + n[0] * ofs, b[1] + n[1] * ofs],
  valoare: Math.hypot(b[0] - a[0], b[1] - a[1]),
  masurat: [[a[0], a[1]], [b[0], b[1]]],
});

/** O față de zid a unei camere, gata de cotat: capetele ei, normala care intră
 *  în cameră și lungimea. */
type Latura = { a: Pt; b: Pt; n: Pt; L: number };

/** CARE DINTRE CELE DOUĂ FEȚE ale aceleiași măsuri îi dă cheia — mereu
 *  aceeași, oricare ar fi fost aleasă la desenare (v. `pereche`). */
const fataCheie = (a: Latura, b: Latura | null): [Pt, Pt] => {
  const seg = (l: Latura): [Pt, Pt] =>
    [[l.a[0], l.a[1]], [l.b[0], l.b[1]]];
  if (!b) return seg(a);
  return cheiaCotei({ a: a.a, b: a.b }) <= cheiaCotei({ a: b.a, b: b.b })
    ? seg(a) : seg(b);
};

/** CÂND SUNT DOUĂ CIFRE ACEEAȘI CIFRĂ: cota se scrie cu două zecimale, deci
 *  sub un centimetru diferența nu se vede — două fețe atât de apropiate ca
 *  lungime poartă același număr scris. */
const TOL_CIFRA = 0.011;

/** CÂT TREBUIE SĂ SE SUPRAPUNĂ DOUĂ FEȚE ca să măsoare același loc. Nu tot:
 *  fețele opuse ale unui coridor sunt decalate cu grosimea zidurilor de la
 *  capete, deci se acoperă 90 %, nu 100 % — iar o zecime de neacoperit nu e
 *  o măsură nouă. */
const SUPRAPUNERE = 0.8;

/** Versorul unei fețe. */
const versorul = (l: Latura): Pt =>
  [(l.b[0] - l.a[0]) / (l.L || 1), (l.b[1] - l.a[1]) / (l.L || 1)];

/** PUNTEA DINTRE DOUĂ FEȚE CARE SPUN ACELAȘI LUCRU — v. regula 5.
 *
 *  Capetele ei sunt picioarele perpendicularei duse la mijlocul suprapunerii
 *  celor două fețe: cu segmentul ăsta se vede pe urmă CE stă între ele. `null`
 *  când fețele nu poartă același număr despre același loc — altă lungime, alt
 *  unghi, sau alături una de alta în loc să fie una în fața alteia. */
function puntea(x: Latura, y: Latura): [Pt, Pt] | null {
  if (Math.abs(x.L - y.L) > TOL_CIFRA) return null;
  const u = versorul(x);
  const v = versorul(y);
  // sinusul unghiului dintre ele: sub o miime, sunt paralele
  if (Math.abs(u[0] * v[1] - u[1] * v[0]) > 1e-3) return null;
  const n: Pt = [-u[1], u[0]];
  const de_a_lungul = (p: Pt) => p[0] * u[0] + p[1] * u[1];
  const de_o_parte = (p: Pt) => p[0] * n[0] + p[1] * n[1];
  const intervalul = (l: Latura) => {
    const s = de_a_lungul(l.a);
    const t = de_a_lungul(l.b);
    return [Math.min(s, t), Math.max(s, t)] as const;
  };
  const [a0, a1] = intervalul(x);
  const [b0, b1] = intervalul(y);
  const i0 = Math.max(a0, b0);
  const i1 = Math.min(a1, b1);
  if (i1 - i0 < SUPRAPUNERE * Math.min(x.L, y.L)) return null;
  const m = (i0 + i1) / 2;
  const pe = (l: Latura): Pt => {
    const d = de_o_parte(l.a);
    return [u[0] * m + n[0] * d, u[1] * m + n[1] * d];
  };
  return [pe(x), pe(y)];
}

/** CÂT DE LUNGĂ POATE FI PUNTEA ca fețele de la capetele ei să fie tot una:
 *  cât cel mai gros zid al planului.
 *
 *  Grosimea se MĂSOARĂ pe plan, nu se scrie aici: pe o planșă cu fațadă de 45
 *  cm «un zid» înseamnă 45 cm, pe una numai cu compartimentări înseamnă 10, iar
 *  o cotă n-are de unde ști dinainte pe care din ele stă. Pragul e generos cu
 *  bună știință — sub el cad și cele două fețe ale unui zid care se oprește
 *  înainte de capătul camerei (o ușă la colț, un ciot rămas din derivare) și
 *  două camere derivate cu un deget de gol între ele: în toate, cifrele ies
 *  una lângă alta pe hârtie, deci a doua e ecou.
 *
 *  Fără niciun zid pe plan rămâne doar puntea de lungime zero — aceeași linie,
 *  două camere lipite. */
function unZidIntre(pereti: readonly { grosime: number }[]): number {
  let g = 0.02;
  for (const w of pereti) g = Math.max(g, w.grosime);
  // Fețele vin din derivarea camerelor, tăiate la colțuri: puntea peste un zid
  // de 30 iese 30,1 cm o dată din două. Un centimetru de joc — cât nu se vede
  // oricum în cifra scrisă (v. `TOL_CIFRA`).
  return g + TOL_CIFRA;
}

/** BANDA COTEI, în metri: fâșia dintre fața zidului și linia de cotă, în care
 *  o piesă de mobilier sau o foaie de ușă chiar cade peste cotă.
 *
 *  E în METRI, nu în pixeli ca restul adnotării, și asta e intenționat: latura
 *  aleasă trebuie să fie aceeași la orice mărire. O cotă care sare de pe o față
 *  pe alta cât dai zoom e mai rea decât una așezată pe fața mai plină. 30 cm e
 *  cât ține depărtarea liniei (16 px) plus corpul cifrei la mărirea de lucru. */
const BANDA_M = 0.3;

/** CE CADE PESTE O COTĂ: conturul fiecărei piese de mobilier și al fiecărei
 *  uși, ca patrulater.
 *
 *  Piesa e dreptunghiul ei rotit — nu cutia axială, care pe o piesă pusă oblic
 *  ar acoperi și colțuri goale. Ușa e golul ei lățit cu baleiajul foii, spre
 *  camera în care se deschide (`spre`): pe planșă arcul ăla e ce traversează
 *  linia de cotă. Golul se lățește și înapoi, cu jumătatea unui zid gros,
 *  fiindcă tocurile stau pe AXUL peretelui, iar cota se măsoară pe FAȚA lui —
 *  altfel o ușă n-ar atinge niciodată banda camerei în care nu baleiază, deși
 *  golul întrerupe fața acolo la fel de tare.
 *
 *  Ferestrele nu intră: ele stau ÎN zid și nu ies în cameră, deci nu se pun
 *  peste nimic. */
function ocupantiiBenzii(plan: PlanTronson): Pt[][] {
  const out: Pt[][] = [];
  for (const f of plan.piese) {
    const r = (f.deg * Math.PI) / 180;
    const cs = Math.cos(r);
    const sn = Math.sin(r);
    out.push(([[-1, -1], [1, -1], [1, 1], [-1, 1]] as const).map(([sx, sy]) => {
      const x = (sx * f.w) / 2;
      const y = (sy * f.h) / 2;
      return [f.c[0] + x * cs - y * sn, f.c[1] + x * sn + y * cs] as Pt;
    }));
  }
  /** Lățirea golului dincolo de axul zidului — jumătatea unui perete gros. */
  const INAPOI = 0.2;
  for (const g of plan.goluri) {
    if (g.fel !== "usa") continue;
    const ux = g.b[0] - g.a[0];
    const uy = g.b[1] - g.a[1];
    const L = Math.hypot(ux, uy);
    if (L < 1e-6) continue;
    let nx = -uy / L;
    let ny = ux / L;
    if (g.spre && (g.spre[0] - g.c[0]) * nx + (g.spre[1] - g.c[1]) * ny < 0) {
      nx = -nx;
      ny = -ny;
    }
    // O ușă glisantă alunecă pe lângă zid, deci nu iese în cameră: rămâne cu
    // lățirea de pe zid.
    const iese = g.model === "sliding" ? INAPOI : Math.max(g.latime, INAPOI);
    out.push(([[g.a, -INAPOI], [g.b, -INAPOI], [g.b, iese], [g.a, iese]] as const)
      .map(([p, d]) => [p[0] + nx * d, p[1] + ny * d] as Pt));
  }
  return out;
}

/** CÂT DE AGLOMERATĂ E BANDA unei laturi: câți ocupanți cad peste ea și cât
 *  din lungimea ei acoperă.
 *
 *  Ocupantul se măsoară în reperul laturii — u de-a lungul ei, v spre cameră —
 *  și se ia cutia lui în reperul ăsta: o cutie mai mare decât patrulaterul
 *  rotit, deci se numără și atingeri care de fapt ratează cota cu un colț.
 *  Greșeala e de partea bună: aici se ALEGE între două fețe, iar o alegere
 *  prudentă nu strică desenul. */
function aglomerarea(l: Latura, ocupanti: readonly Pt[][]):
    { nr: number; acoperit: number } {
  const ux = (l.b[0] - l.a[0]) / (l.L || 1);
  const uy = (l.b[1] - l.a[1]) / (l.L || 1);
  let nr = 0;
  let acoperit = 0;
  for (const o of ocupanti) {
    let u0 = Infinity, u1 = -Infinity, v0 = Infinity, v1 = -Infinity;
    for (const p of o) {
      const dx = p[0] - l.a[0];
      const dy = p[1] - l.a[1];
      const u = dx * ux + dy * uy;
      const v = dx * l.n[0] + dy * l.n[1];
      u0 = Math.min(u0, u); u1 = Math.max(u1, u);
      v0 = Math.min(v0, v); v1 = Math.max(v1, v);
    }
    if (v1 <= 0.01 || v0 >= BANDA_M) continue;
    const i0 = Math.max(0, u0);
    const i1 = Math.min(l.L, u1);
    if (i1 - i0 <= 0.01) continue;
    nr++;
    acoperit += i1 - i0;
  }
  return { nr, acoperit };
}

/** DIN DOUĂ FEȚE CARE SPUN LA FEL, care primește cota și care rămâne rezervă:
 *  cea peste care cad mai puțini ocupanți, iar la număr egal cea pe care
 *  aceștia acoperă mai puțin — v. regula 6. Egale de tot — o cameră goală —,
 *  rămâne prima, ca desenul să nu se schimbe de la o redesenare la alta. */
function maiLibera(x: Latura, y: Latura, ocupanti: readonly Pt[][]):
    { fata: Latura; rezerva: Latura } {
  const a = aglomerarea(x, ocupanti);
  const b = aglomerarea(y, ocupanti);
  const treceY = b.nr !== a.nr ? b.nr < a.nr : b.acoperit < a.acoperit - 0.01;
  return treceY ? { fata: y, rezerva: x } : { fata: x, rezerva: y };
}

/** FEȚELE UNUI INEL, ÎMPERECHEATE — o cotă de fiecare pereche.
 *
 *  Inelul e al unei camere sau al conturului. Fețele lui care spun același
 *  lucru (`puntea`) se iau două câte două, iar din pereche se scrie cea mai
 *  liberă; cealaltă rămâne rezervă, pentru cazul în care prima nu încape.
 *  Fața fără pereche se cotează singură.
 *
 *  Aici s-a desființat cazul special «camera e dreptunghi»: un dreptunghi n-are
 *  nimic deosebit, doar întâmplarea că amândouă perechile lui de fețe se
 *  suprapun cap la cap. Coridorul în L, camera în T și conturul modulului cad
 *  sub aceeași socoteală, și tocmai ele scriau dublurile. */
function perechileInelului(ring: readonly Pt[], ocupanti: readonly Pt[][]):
    { fata: Latura; rezerva: Latura | null }[] {
  const fete: Latura[] = ring.map((a, i) => {
    const b = ring[(i + 1) % ring.length];
    return { a, b, n: normalaInauntru(a, b, ring),
             L: Math.hypot(b[0] - a[0], b[1] - a[1]) };
  });
  const luate = new Set<number>();
  const out: { fata: Latura; rezerva: Latura | null }[] = [];
  for (let i = 0; i < fete.length; i++) {
    if (luate.has(i)) continue;
    let j = -1;
    for (let q = i + 1; q < fete.length && j < 0; q++) {
      if (!luate.has(q) && puntea(fete[i], fete[q])) j = q;
    }
    if (j < 0) { out.push({ fata: fete[i], rezerva: null }); continue; }
    luate.add(j);
    out.push(maiLibera(fete[i], fete[j], ocupanti));
  }
  return out;
}

/** DEPĂRTAREA LINIEI DE FAȚA EI NU E UN NUMĂR, E UN INTERVAL, în pixeli.
 *
 *  16 px fix era o poziție luată pe nevăzute: cifra cădea unde cădea, iar pe o
 *  planșă mobilată cădea peste pat, peste vasul de closet, peste parapetul
 *  balconului — pe catalog, una din patru — și acolo nu se mai citește nici ea,
 *  nici desenul de sub ea. O
 *  cotă e o adnotare: ea are voie să se dea puțin la o parte, cât timp rămâne
 *  vizibil a FEȚEI ei. Atât înseamnă intervalul: linia pleacă de la 11 px de
 *  zid și poate ajunge la 56, din 3 în 3, iar dintre treptele astea alege
 *  `costul` (v. mai jos). Mai aproape de 11 px vine doar ca să se alinieze —
 *  v. `minAliniere`.
 *
 *  Mai departe de-atât nu are voie să meargă, oricât de plină ar fi camera: o
 *  linie ajunsă la mijlocul încăperii nu se mai citește ca măsura unei fețe, ci
 *  ca o cotă fără stăpân. De-aia depărtarea se mai taie de două ori — la o
 *  treime din cât e până la zidul din față (v. `adancimea`) și la
 *  `DEPARTARE_MAX_M`. */
const DEPARTARE_PX = {
  min: 11, max: 56, pas: 3,
  /** DOAR CA SĂ SE ALINIEZE poate veni mai aproape de-atât. O linie singură la
   *  8 px de zid pare lipită de el; una care se așază pe o linie EXISTENTĂ nu
   *  mai e singură, ci o continuă, iar continuarea se citește de la prima. Fără
   *  scăderea asta alinierea ar merge doar într-o parte: cota vecinei mai
   *  dinăuntru poate ieși spre linie, cea a vecinei mai din afară n-ar mai avea
   *  cum să se ducă spre ea. */
  minAliniere: 8,
} as const;

/** ȘI NICIODATĂ MAI DEPARTE DE-ATÂT, în METRI — singura mărime a adnotării
 *  care nu e în pixeli, și cu bună știință. Pixelii spun cât de departe arată
 *  linia pe ecran; metrul ăsta spune cât de departe mai poate fi de zidul ei ca
 *  să se mai citească drept măsura LUI. La mărirea de ansamblu 56 px sunt un
 *  metru și jumătate de plan — o cotă plecată atât din perete nu mai e a
 *  peretelui, e o linie rătăcită prin cameră. */
const DEPARTARE_MAX_M = 0.9;

/** O PIEDICĂ ÎN CALEA LINIEI: conturul unui obiect și felul lui.
 *
 *  Zidul se deosebește de restul fiindcă o cotă scrisă ÎN el nu se mai citește
 *  deloc — hașura trece peste cifră și cifra peste hașură —, pe când una peste
 *  un dulap se mai ghicește. Deci nu sunt două reguli, ci două greutăți ale
 *  aceleiași reguli. */
type Piedica = {
  pts: readonly Pt[]; zid: boolean;
  /** Cutia ei în planul planșei. E doar o sită: cu ea se aruncă, dintr-o
   *  scădere, piedicile care nici n-au cum să ajungă în dreptul unei fețe —
   *  pe un modul cu trei sute de ziduri și piese, aia e aproape toată munca. */
  c: Cutie;
};

/** Tot ce poate sta în calea unei cote de planșă: mobilierul și ușile
 *  (`ocupantiiBenzii`) plus ZIDURILE, care până acum nu erau socotite nicăieri
 *  — de-acolo venea «2,25» înfiptă în parapetul balconului lui M5.
 *
 *  Un perete NESECȚIONAT nu trece drept zid aici: parapetul unui balcon e sub
 *  tăietura planului, deci se desenează cu linia subțire pe hârtie albă, fără
 *  hașură (v. `Desen::subTaietura`). O cifră peste el se citește ca una peste o
 *  piesă de mobilier — de evitat, dar nu de fugit cu orice preț. */
function piedicile(plan: PlanTronson): Piedica[] {
  const cutia = (pts: readonly Pt[]): Cutie => ({
    x0: Math.min(...pts.map((q) => q[0])), x1: Math.max(...pts.map((q) => q[0])),
    y0: Math.min(...pts.map((q) => q[1])), y1: Math.max(...pts.map((q) => q[1])),
  });
  const out: Piedica[] = ocupantiiBenzii(plan)
    .map((pts) => ({ pts, zid: false, c: cutia(pts) }));
  for (const w of plan.pereti) {
    out.push({ pts: w.inel, zid: !w.subTaietura, c: cutia(w.inel) });
  }
  return out;
}

/** Dreptunghiul `[u0,u1] × [v0,v1]` chiar atinge poligonul, nu doar cutia lui?
 *
 *  Cutia e o minciună binevoitoare cât timp doar cerne — dar pe un parapet în U,
 *  care ține tot balconul în cutia lui și e gol pe dinăuntru, minciuna costă o
 *  cotă: nicio depărtare nu părea liberă, deși erau trei sferturi de balcon
 *  liber. Deci după cutie se răspunde exact: se ating dacă un vârf al
 *  poligonului cade în dreptunghi, dacă un colț al dreptunghiului cade în
 *  poligon, sau dacă două laturi se taie. */
function atingePoligonul(pts: readonly [number, number][],
                         u0: number, u1: number, v0: number, v1: number): boolean {
  for (const [u, v] of pts) {
    if (u >= u0 && u <= u1 && v >= v0 && v <= v1) return true;
  }
  const inauntruPoli = (u: number, v: number) => {
    let da = false;
    for (let i = 0, j = pts.length - 1; i < pts.length; j = i++) {
      const [ui, vi] = pts[i];
      const [uj, vj] = pts[j];
      if ((vi > v) !== (vj > v)
          && u < ((uj - ui) * (v - vi)) / (vj - vi || 1e-12) + ui) da = !da;
    }
    return da;
  };
  if (inauntruPoli(u0, v0) || inauntruPoli(u1, v1)) return true;
  const taie = (ax: number, ay: number, bx: number, by: number,
                cx: number, cy: number, dx: number, dy: number) => {
    const s = (px: number, py: number, qx: number, qy: number,
               rx: number, ry: number) =>
      Math.sign((qx - px) * (ry - py) - (qy - py) * (rx - px));
    return s(ax, ay, bx, by, cx, cy) !== s(ax, ay, bx, by, dx, dy)
        && s(cx, cy, dx, dy, ax, ay) !== s(cx, cy, dx, dy, bx, by);
  };
  const colturi: [number, number][] =
    [[u0, v0], [u1, v0], [u1, v1], [u0, v1]];
  for (let i = 0; i < pts.length; i++) {
    const [ax, ay] = pts[i];
    const [bx, by] = pts[(i + 1) % pts.length];
    for (let q = 0; q < 4; q++) {
      const [cx, cy] = colturi[q];
      const [dx, dy] = colturi[(q + 1) % 4];
      if (taie(ax, ay, bx, by, cx, cy, dx, dy)) return true;
    }
  }
  return false;
}

/** Piedicile în REPERUL UNEI FEȚE: de-a lungul ei (`u`, de la capătul `a`) și
 *  depărtat de ea pe direcția în care pleacă linia (`v`). Se socotesc o dată
 *  pentru toată fața, fiindcă toate depărtările încercate pe urmă se uită la
 *  aceleași cutii; ce nu e în dreptul feței nici nu intră în listă.
 *
 *  Cutia e cea AXIALĂ în reperul ăsta, deci mai mare decât patrulaterul rotit:
 *  se numără și atingeri care de fapt ratează linia cu un colț. Greșeala e de
 *  partea bună — aici se alege între depărtări, iar o alegere prudentă nu
 *  strică desenul. */
type Proiectie = {
  u0: number; u1: number; v0: number; v1: number; zid: boolean;
  /** Vârfurile, în același reper — cu ele se răspunde exact când cutia spune
   *  că s-ar putea atinge (v. `atingePoligonul`). */
  pts: [number, number][];
  /** Piedica ESTE cutia ei: un zid drept, văzut de-a lungul unei fețe paralele
   *  cu el, umple exact dreptunghiul. Atunci răspunsul exact e cel al cutiei,
   *  iar socoteala scumpă se sare — și se sare aproape mereu, fiindcă mai toți
   *  pereții planșei sunt dreptunghiuri paralele cu fețele camerelor. */
  dreapta: boolean;
};

function inReperulFetei(l: Latura, spre: Pt, piedici: readonly Piedica[],
                        raza: number): Proiectie[] {
  const ux = (l.b[0] - l.a[0]) / (l.L || 1);
  const uy = (l.b[1] - l.a[1]) / (l.L || 1);
  // Sita: fâșia în care poate cădea linia, oricare ar fi depărtarea aleasă.
  const sx0 = Math.min(l.a[0], l.b[0]) - raza;
  const sx1 = Math.max(l.a[0], l.b[0]) + raza;
  const sy0 = Math.min(l.a[1], l.b[1]) - raza;
  const sy1 = Math.max(l.a[1], l.b[1]) + raza;
  const out: Proiectie[] = [];
  for (const q of piedici) {
    if (q.c.x1 < sx0 || q.c.x0 > sx1 || q.c.y1 < sy0 || q.c.y0 > sy1) continue;
    let u0 = Infinity, u1 = -Infinity, v0 = Infinity, v1 = -Infinity;
    const pts: [number, number][] = [];
    for (const p of q.pts) {
      const dx = p[0] - l.a[0];
      const dy = p[1] - l.a[1];
      const u = dx * ux + dy * uy;
      const v = dx * spre[0] + dy * spre[1];
      u0 = Math.min(u0, u); u1 = Math.max(u1, u);
      v0 = Math.min(v0, v); v1 = Math.max(v1, v);
      pts.push([u, v]);
    }
    if (u1 <= 0.01 || u0 >= l.L - 0.01) continue;
    const e = 1e-6;
    const peColt = ([u, v]: [number, number]) =>
      (Math.abs(u - u0) < e || Math.abs(u - u1) < e)
      && (Math.abs(v - v0) < e || Math.abs(v - v1) < e);
    out.push({ u0, u1, v0, v1, zid: q.zid, pts,
               dreapta: pts.length === 4 && pts.every(peColt) });
  }
  return out;
}

/** CÂT E PÂNĂ LA ZIDUL DIN FAȚĂ, măsurat pe direcția în care pleacă linia.
 *  Cu el se taie depărtarea, ca o cotă să nu ajungă la mijlocul camerei. */
function adancimea(pr: readonly Proiectie[]): number {
  let d = Infinity;
  for (const p of pr) if (p.zid && p.v0 > 0.02) d = Math.min(d, p.v0);
  return d;
}

/** LINIA PE CARE STĂ O COTĂ, în reperul planului: direcția ei — întoarsă
 *  întotdeauna în aceeași jumătate de cerc, ca două fețe parcurse în sensuri
 *  opuse să se recunoască una pe alta — și cât e de o parte.
 *
 *  Cu ea se ține evidența liniilor deja desenate, iar o cotă nouă poate să se
 *  așeze chiar pe una din ele: asta e ALINIEREA. */
type Linie = { ux: number; uy: number; d: number };

function liniaPrin(a: Pt, b: Pt): Linie {
  const L = Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
  let ux = (b[0] - a[0]) / L;
  let uy = (b[1] - a[1]) / L;
  if (ux < -1e-9 || (Math.abs(ux) <= 1e-9 && uy < 0)) { ux = -ux; uy = -uy; }
  return { ux, uy, d: -a[0] * uy + a[1] * ux };
}

/** COTELE PLANȘEI, așezate.
 *
 *  `k` e mărirea, în pixeli pe metru. `ocupate` sunt dreptunghiurile deja
 *  scrise — numele și ariile camerelor —, peste care nu se pune nimic; lista
 *  primită NU se modifică, cotele își țin propria evidență pornind de la ea.
 */
/** CHEIA UNEI COTE: capetele a CE MĂSOARĂ ea, rotunjite la centimetru.
 *
 *  O cotă socotită nu are identitate în document — se naște din nou la fiecare
 *  desenare —, deci «cota asta a fost ștearsă» se ține minte pe geometria ei.
 *  Rotunjită la centimetru, fiindcă desenul se așază oricum pe grila de 5 cm,
 *  iar o cheie pe milimetri s-ar desface la prima rotunjire. Capetele se scriu
 *  în ordine, ca a→b și b→a să dea aceeași cheie: o cotă e un segment, nu o
 *  săgeată.
 *
 *  PE FAȚA MĂSURATĂ, NU PE LINIA DESENATĂ. `a`/`b` sunt fața împinsă afară cu
 *  o depărtare socotită în PIXELI (`COTA_PX.afara / k` și celelalte), deci se
 *  mută la fiecare mărire: din 84 de chei ale aceleiași planșe, 37 se schimbau
 *  între două măriri vecine și TOATE între 46 și 92 px/m. O cotă ștearsă
 *  rămânea ștearsă numai la mărirea la care fusese ștearsă, și se întorcea la
 *  prima rotiță de scroll sau la reîncărcarea paginii — «the cota still
 *  appears after deleted» (15.10.2026). Fața măsurată stă pe loc. */
export function cheiaCotei(c: { a: Pt; b: Pt; masurat?: [Pt, Pt] }): string {
  const [a, b] = c.masurat ?? [c.a, c.b];
  const r = (p: Pt) => `${Math.round(p[0] * 100)},${Math.round(p[1] * 100)}`;
  const [u, v] = [r(a), r(b)].sort();
  return `${u}|${v}`;
}

export function cotelePlanului(plan: PlanTronson, k: number,
                               ocupate: readonly Cutie[],
                               zidAles?: number | null): Cota[] {
  if (!(k > 0)) return [];
  const stinse = new Set(plan.coteStinse ?? []);
  const puse: Cutie[] = [...ocupate];
  /** Fețele ale căror măsuri au ajuns pe planșă — cu ele se recunoaște cota
   *  care ar repeta un număr scris deja dincolo de zid (regula 5). */
  const scrise: Latura[] = [];
  /** Liniile deja desenate — pe ele se aliniază cele care urmează (regula 7). */
  const linii: Linie[] = [];
  const out: Cota[] = [];
  const zid = unZidIntre(plan.pereti);
  const toate = piedicile(plan);

  /** Măsura feței e scrisă deja, dincolo de un zid? — regula 5. */
  const scrisaDeja = (f: Latura) => scrise.some((g) => {
    const pod = puntea(f, g);
    return !!pod
      && Math.hypot(pod[1][0] - pod[0][0], pod[1][1] - pod[0][1]) <= zid;
  });

  /** CE COSTĂ O DEPĂRTARE — regulile 6, 7 și 8, într-un singur număr, ca să se
   *  poată compara între ele lucruri care altfel n-ar fi comparabile.
   *
   *  Greutățile spun ordinea, nu niște cifre alese frumos: un zid peste care
   *  s-ar scrie cifra e mai rău decât o piesă de mobilier, o piesă e mai rea
   *  decât o linie nealiniată, iar între două așezări la fel de bune câștigă
   *  cea mai apropiată de depărtarea firească. Nimic nu e interzis — o cameră
   *  în care TOATE treptele dau peste ceva își primește totuși cota, pe treapta
   *  cea mai puțin rea, fiindcă o cameră necotată e mai rău decât una cotată
   *  peste un dulap. */
  const costul = (pr: readonly Proiectie[], l: number, o: number, t: number,
                  ofs0: number, aliniata: boolean, text: string,
                  abatere: number): { cost: number; sub: number } => {
    // Fâșia pe care o ocupă linia cu cifra ei: corpul literei, cu puțin peste.
    const h2 = (COTA_PX.corp * 0.7) / k;
    const w2 = (latimeaCifrei(text, COTA_PX.corp) / 2 + COTA_PX.perna) / k;
    const c0 = t - w2;
    const c1 = t + w2;
    let cost = (aliniata ? 0 : 5) + 6 * abatere;
    let sub = 0;
    for (const p of pr) {
      if (p.v1 <= o - h2 || p.v0 >= o + h2) continue;
      if (!p.dreapta && !atingePoligonul(p.pts, 0, l, o - h2, o + h2)) continue;
      // Sub cifră e mai rău decât pe linie: linia se întrerupe oricum acolo
      // unde stă numărul, deci o piesă prinsă între buline strică mai puțin
      // decât una peste care cade chiar cifra.
      const subCifra = p.u1 > c0 && p.u0 < c1
        && (p.dreapta || atingePoligonul(p.pts, c0, c1, o - h2, o + h2));
      cost += p.zid ? 40 : 10;
      if (subCifra) sub += p.zid ? 40 : 8;
    }
    return { cost: cost + sub + 0.12 * Math.abs(o - ofs0) * k, sub };
  };

  /** AȘEZAREA UNEI FEȚE: cota ei, pe cea mai bună dintre așezările încercate —
   *  depărtarea liniei de zid și locul cifrei pe linie. `null` când măsura nu
   *  încape pe latura ei (regula 2) sau când nicio așezare nu lasă cifra liberă
   *  de ce e scris deja (regula 3).
   *
   *  Nu scrie nimic: cine o cheamă compară întâi cele două fețe ale unei
   *  perechi și abia pe urmă pune. */
  const asezarea = (f: Latura, spre: Pt, ofs0: number, afara = false):
      { c: Cota; cost: number } | null => {
    if (f.L * k < lungimeaMinima(f.L)) return null;
    const text = textul(f.L);
    const w2 = (latimeaCifrei(text, COTA_PX.corp) / 2 + COTA_PX.perna) / k;
    // Sita trebuie să prindă și zidul care doar TAIE depărtarea fără să stea
    // în calea liniei: peste `DEPARTARE_MAX_M / 0.33` metri, tăierea lui e mai
    // largă decât plafonul în metri, deci n-ar mai schimba nimic (v. `sus`).
    const raza = Math.max(DEPARTARE_PX.max / k, DEPARTARE_MAX_M / 0.33)
      + (COTA_PX.corp * 0.7) / k;
    const pr = inReperulFetei(f, spre, toate, raza);
    // ÎN AFARA CONTURULUI NU EXISTĂ «ZIDUL DIN FAȚĂ». Zidul pe care-l vede o
    // latură a conturului scobit — brațul celălalt al unui modul în L — nu e
    // în fața ei, e altă parte a aceleiași clădiri: cota de ansamblu are voie
    // să treacă dincolo de el, cum trece pe orice planșă. Cu tăierea pusă și
    // acolo, «2,25» de la scobitura lui M5 rămânea înfiptă în hașură.
    const sus = Math.max(DEPARTARE_PX.min / k,
                         Math.min(DEPARTARE_PX.max / k, DEPARTARE_MAX_M,
                                  afara ? Infinity : 0.33 * adancimea(pr)));
    const jos = Math.min(DEPARTARE_PX.min / k, sus);

    // TREPTELE DEPĂRTĂRII: cele din interval, plus cele care ar pune linia
    // CHIAR pe o linie desenată deja — alea sunt alinierile (regula 7), și tot
    // ele sunt tot ce se cheamă «puțin mai sus sau mai jos».
    const trepte: { o: number; aliniata: boolean }[] = [];
    for (let px = DEPARTARE_PX.min; px <= DEPARTARE_PX.max; px += DEPARTARE_PX.pas) {
      const o = px / k;
      if (o >= jos - 1e-9 && o <= sus + 1e-9) trepte.push({ o, aliniata: false });
    }
    if (ofs0 >= jos - 1e-9 && ofs0 <= sus + 1e-9) {
      trepte.push({ o: ofs0, aliniata: false });
    }
    const mea = liniaPrin(f.a, f.b);
    const s = spre[0] * -mea.uy + spre[1] * mea.ux;
    if (Math.abs(s) > 0.5) {
      for (const L of linii) {
        if (Math.abs(mea.ux * L.uy - mea.uy * L.ux) > 1e-3) continue;
        const o = (L.d - mea.d) / s;
        const josAliniere = Math.min(DEPARTARE_PX.minAliniere / k, sus);
        if (o >= josAliniere - 1e-9 && o <= sus + 1e-9) {
          trepte.push({ o, aliniata: true });
        }
      }
    }

    // LOCURILE CIFREI PE LINIE: mijlocul, și — dacă la mijloc n-o duce bine —
    // alunecări de-o parte și de alta, atât cât cifra să rămână întreagă între
    // buline. Mijlocul e primul și e gratis; restul se plătesc (v. `costul`).
    const marg = w2 + (2 * COTA_PX.bulina + 5) / k;
    const t0 = Math.min(marg, f.L / 2);
    const t1 = Math.max(f.L - marg, f.L / 2);
    const brat = (t1 - t0) / 2;
    const alunecari: { t: number; abatere: number }[] = [];
    if (brat > 1e-6) {
      for (const q of [0.35, 0.7, 1]) {
        for (const semn of [-1, 1]) {
          alunecari.push({ t: f.L / 2 + semn * q * brat, abatere: q });
        }
      }
    }

    // NUMAI PIEDICILE CARE POT AJUNGE ÎN DREPTUL LINIEI, oricare ar fi treapta
    // aleasă — restul sunt de partea cealaltă a camerei și n-au ce căuta în
    // bucla de mai jos. Pe un modul mare taie nouă zecimi din socoteală.
    const h2 = (COTA_PX.corp * 0.7) / k;
    const prUtile = pr.filter((q) => q.v1 > jos - h2 && q.v0 < sus + h2);

    let bun: { c: Cota; cost: number } | null = null;
    let nevoie = false;
    /** O așezare respinsă fiindcă cifra ei ar cădea peste ceva scris deja —
     *  alunecarea o poate salva, deci merită încercată chiar dacă cea aleasă
     *  nu are nimic sub cifră. */
    let respins = false;
    const incearcaLocul = (o: number, aliniata: boolean,
                           loc: { t: number; abatere: number }) => {
      const c = cota(f.a, f.b, spre, o);
      c.la = loc.t / (f.L || 1);
      const cut = cutiaCifrei(c, k);
      if (puse.some((q) => seAting(q, cut))) { respins = true; return; }
      const r = costul(prUtile, f.L, o, loc.t, ofs0, aliniata, text,
                       loc.abatere);
      if (!bun || r.cost < bun.cost - 1e-9) {
        bun = { c, cost: r.cost };
        nevoie = r.sub > 0;
      }
    };

    // ÎNTÂI CU CIFRA LA MIJLOC, pe toate treptele. Alunecarea se încearcă doar
    // dacă cea mai bună așezare cu cifra la mijloc tot are ceva sub cifră:
    // altfel s-ar socoti de șapte ori mai mult degeaba, la fiecare mărire.
    const mijloc = { t: f.L / 2, abatere: 0 };
    for (const tr of trepte) incearcaLocul(tr.o, tr.aliniata, mijloc);
    if ((!bun || nevoie || respins) && alunecari.length) {
      for (const tr of trepte) {
        for (const loc of alunecari) incearcaLocul(tr.o, tr.aliniata, loc);
      }
    }
    // Mijlocul nu se scrie degeaba: o cotă care n-a avut nevoie să alunece
    // rămâne o cotă obișnuită.
    if (bun && Math.abs(((bun as { c: Cota }).c.la ?? 0.5) - 0.5) < 1e-9) {
      delete (bun as { c: Cota }).c.la;
    }
    return bun;
  };

  const scrie = (f: Latura, a: { c: Cota; cost: number }) => {
    puse.push(cutiaCifrei(a.c, k));
    scrise.push(f);
    linii.push(liniaPrin(a.c.a, a.c.b));
    out.push(a.c);
  };

  /** O PERECHE DE FEȚE, așezată: măsura e una singură, deci se scrie o singură
   *  dată, pe fața pe care iese mai bine.
   *
   *  `maiLibera` a spus deja care e favorita; aici se compară AȘEZĂRILE lor
   *  adevărate, cu tot cu depărtarea aleasă, fiindcă abia ele știu dacă cifra
   *  chiar încape și peste ce cade. Favorita câștigă la egalitate, ca desenul
   *  să nu sară de la o redesenare la alta. Dacă măsura e DEJA SCRISĂ dincolo
   *  de zid, nu se mai încearcă nimic: ar aduce înapoi cifra tocmai tăiată. */
  const pereche = (p: { fata: Latura; rezerva: Latura | null },
                   spre: (l: Latura) => Pt, ofs0: number, afara = false) => {
    if (scrisaDeja(p.fata)) return;
    const a = asezarea(p.fata, spre(p.fata), ofs0, afara);
    const b = p.rezerva && !scrisaDeja(p.rezerva)
      ? asezarea(p.rezerva, spre(p.rezerva), ofs0, afara) : null;
    // ACEEAȘI CHEIE, pe oricare dintre cele două fețe s-ar scrie măsura.
    // Care câștigă se hotărăște din așezare, iar așezarea ține de mărire: la
    // 46 px/m cifra încape pe fața dinăuntru, la 92 pe cea de dincolo. Cheia
    // luată de pe fața câștigătoare s-ar fi schimbat odată cu ea, și cota
    // ștearsă s-ar fi întors pe sora ei (v. `cheiaCotei`).
    const m = fataCheie(p.fata, p.rezerva);
    if (a && (!b || b.cost >= a.cost - 1e-9)) {
      scrie(p.fata, { ...a, c: { ...a.c, masurat: m } });
    } else if (b) scrie(p.rezerva!, { ...b, c: { ...b.c, masurat: m } });
  };

  // 1. ansamblul: conturul modulului, în afară — deci pe normala «înăuntru»
  //    a conturului, întoarsă. Laturile opuse ale unui contur dreptunghiular
  //    se împerechează ca ale oricărei camere: lățimea o dată, adâncimea o
  //    dată. Nu e mobilier afară, deci n-are ce alege între ele.
  const afara = (l: Latura): Pt => [-l.n[0], -l.n[1]];
  for (const p of perechileInelului(faraColinear(plan.anvelopa), [])) {
    pereche(p, afara, COTA_PX.afara / k, true);
  }

  // 2. UȘILE, fiecare cu golul ei pe înălțime — v. regula 10. Înaintea
  //    camerelor: ele n-au de ales locul, cota unei camere are.
  //
  //    Regulile 3 și 8 rămân ale lor: cifra nu se pune peste ce e scris deja
  //    și nu se pune în hașură — de obicei nu zidul ei o amenință, ci cel
  //    PERPENDICULAR de la colț, în care intră numărul cu vreo zece
  //    centimetri, fiindcă el e mai lat decât golul. De-aia sunt trei trepte
  //    de depărtare: de pe prima, numărul se retrage în cameră.
  for (const g of plan.goluri) {
    if (g.fel !== "usa") continue;
    const text = textulCotei({ valoare: g.latime, si: g.inaltime });
    if (latimeaCifrei(text, COTA_PX.corpGol) > INTINDEREA_GOLULUI * g.latime * k) {
      continue;
    }
    for (const px of DEPARTARI_GOL) {
      const c0 = cotaUsii(plan, g, px / k);
      if (!c0) break;
      const c: Cota = { ...c0, corp: COTA_PX.corpGol, usa: g.idx };
      const cut = cutiaCifrei(c, k);
      if (puse.some((q) => seAting(q, cut))) continue;
      // Hașura se ferește de TUȘ, nu de pernă (v. `cutiaCifrei`).
      const tus = cutiaCifrei(c, k, 0);
      if (toate.some((q) => q.zid && seAting(q.c, tus)
                         && atingePoligonul(q.pts, tus.x0, tus.x1,
                                            tus.y0, tus.y1))) continue;
      puse.push(cut);
      out.push(c);
      break;
    }
  }

  // 3. camerele: toate fețele, cele lungi întâi — v. regulile 3 și 7. Ordinea
  //    e și a alinierii: laturile mari trag liniile, cele mici se așază pe ele.
  const ocupanti = ocupantiiBenzii(plan);
  const inauntru = (l: Latura): Pt => l.n;
  const perechi: { fata: Latura; rezerva: Latura | null }[] = [];
  for (const c of plan.camere) {
    // regula 4: o cameră în care cifra n-ar încăpea între zid și zidul din față
    if (c.mic * k < COTA_PX.inauntru + COTA_PX.corp * 1.2 + 4) continue;
    const ring = faraColinear(c.inel);
    if (ring.length < 3) continue;
    perechi.push(...perechileInelului(ring, ocupanti));
  }
  perechi.sort((p, q) => q.fata.L - p.fata.L);
  for (const p of perechi) pereche(p, inauntru, COTA_PX.inauntru / k);

  // 4. ARCADELE — golurile dintre două ziduri colineare
  //    (v. `golurileDintreZiduri`). Un gol în perete, nu o cameră: cifra lui e
  //    a GOLULUI, ca a unei uși.
  //
  //    O SPĂRTURĂ NU LĂSA NICIO CIFRĂ. Măsurat pe planul real (catalogul de pe
  //    prod, «2 CAMERE PREMIUM CAPAT» v4): `cotelePlanului` întorcea EXACT
  //    aceleași 51 de cote înainte și după o spărtură de 0,85 m, cuvânt cu
  //    cuvânt — deci cifra pe care o citea omul lângă gaură era a altcuiva
  //    («I make an opening of 0.85 and when I click to set it I get a cota of
  //    0.73», 21.10.2026).
  //
  //    LA URMĂ, DUPĂ CAMERE, și asta e esențial: o arcadă e o cifră ÎN PLUS, în
  //    timp ce cota unei camere e una pe care planșa o datorează. Așezate
  //    înaintea lor, arcadele le mâncau locul din `puse` și holul lui M1 ieșea
  //    cu 3 cote din 6. Deci ele iau ce rămâne — iar dacă nu rămâne nimic, nu
  //    se scriu: o cameră necotată e mai rău decât o arcadă necotată.
  //
  //    ȘI TREC PRIN REGULA 5, ca orice măsură: fără ea, un gol de 1,60 m lângă o
  //    cameră de 1,60 m scria «1,60» a doua oară, dincolo de zid (`M1 la
  //    60 px/m: «1.60» de două ori`). De-aia își face o `Latura` și intră în
  //    `scrise`, nu doar în `puse`.
  for (const g of golurileDintreZiduri(plan)) {
    const text = textulCotei({ valoare: g.latime });
    if (latimeaCifrei(text, COTA_PX.corpGol) > INTINDEREA_GOLULUI * g.latime * k) {
      continue;
    }
    // Fața golului, ca orice altă față: cu ea se întreabă regula 5.
    const L = Math.hypot(g.b[0] - g.a[0], g.b[1] - g.a[1]) || 1;
    const fata: Latura = {
      a: g.a, b: g.b, L: g.latime,
      n: [-(g.b[1] - g.a[1]) / L, (g.b[0] - g.a[0]) / L],
    };
    if (scrisaDeja(fata)) continue;
    // DEPĂRTAREA ÎNTÂI, PARTEA PE URMĂ: mai bine aceeași parte puțin mai
    // departe decât cealaltă parte lipită de zid — o cotă sare mai puțin în
    // ochi mutată de-a latul decât trecută dincolo de perete.
    let pus = false;
    for (const px of DEPARTARI_ARCADA) {
      for (const semn of [-1, 1] as const) {
        const c0 = cotaArcadei(g, g.grosime, px / k, semn);
        if (!c0) break;
        const c: Cota = { ...c0, corp: COTA_PX.corpGol, arcada: true };
        const cut = cutiaCifrei(c, k);
        if (puse.some((q) => seAting(q, cut))) continue;
        // Hașura se ferește de TUȘ, nu de pernă (v. `cutiaCifrei`).
        const tus = cutiaCifrei(c, k, 0);
        if (toate.some((q) => q.zid && seAting(q.c, tus)
                           && atingePoligonul(q.pts, tus.x0, tus.x1,
                                              tus.y0, tus.y1))) continue;
        // ȘI LINIA, nu doar cifra: o cotă de arcadă pleacă de pe fața zidului,
        // deci la depărtările mari trece peste pereții din jur. Cifra putea
        // încăpea curat în timp ce LINIA ei tăia un zid (`M1 la 60 px/m:
        // 1 linii prin zid`). Se măsoară ca pe planșă — pe puncte de-a lungul
        // ei —, fiindcă un zid poate fi străbătut și fără să cuprindă vreun
        // capăt.
        if (prinZid(c, plan)) continue;
        if (ecouScris(c, out, k)) continue;
        puse.push(cut);
        scrise.push(fata);
        linii.push(liniaPrin(c.a, c.b));
        out.push(c);
        pus = true;
        break;
      }
      if (pus) break;
    }
  }
  // FIECARE COTĂ ÎȘI AFLĂ ZIDUL, ca să se poată scrie în ea.
  //
  // Cotele planșei măsoară fețe de zid, iar până acum nu purtau cu ele nimic
  // din care să se știe CE zid: `muta` lipsea dinadins, cu motivul că «o față
  // nu se mută singură de la cealaltă». Numai că se mută — e chiar gestul pe
  // care-l face mâna trăgând de perete —, iar cifra e locul firesc în care se
  // cere («să fie editabilă cota în camere… să miște zidul și pe cele
  // alăturate din cameră», 13.10.2026).
  //
  // Se caută aici, la urmă, nu înăuntrul construcției: `pereche` lucrează pe
  // fețe (`Latura`), care n-au indice de zid, iar o căutare geometrică la
  // capăt e cu mult mai puțin cod decât purtatul indicelui prin tot drumul.
  // COTELE PUSE DE MÂNĂ, lângă cele socotite — și cele stinse, scoase.
  //
  // Puse LA SFÂRȘIT, ca să nu intre în socoteala care ocolește suprapunerile:
  // o cotă trasă de om stă unde a tras-o el, chiar dacă se atinge de alta.
  const alePlansei = out
    .filter((c) => !stinse.has(cheiaCotei(c)))
    .map((c) => (c.usa != null || c.muta ? c : cuZidulEi(plan, c, zidAles)));
  const deMana: Cota[] = (plan.coteDeMana ?? []).map((c) => ({
    a: c.a, b: c.b,
    valoare: Math.hypot(c.b[0] - c.a[0], c.b[1] - c.a[1]),
    deMana: true,
  }));
  return [...alePlansei, ...deMana];
}

/** Felurile de cameră care sunt AFARĂ — ele nu cresc niciodată într-o odaie. */
const AFARA = new Set(["balcony", "terasa", "terasa_circulabila", "loggia"]);

/** Cota planșei, cu zidul de la capătul ei — dacă i se găsește unul.
 *
 *  BALCONUL CREȘTE SPRE AFARĂ, NICIODATĂ ÎN APARTAMENT.
 *  ======================================================
 *  Un balcon are două laturi pe axa lui: una spre gol și una comună cu odaia
 *  de alături. Mutat zidul comun, balconul se mărește mâncând din cameră — pe
 *  planșa ei, 13,67 → 14,20 m² de balcon plătiți cu 42,47 → 41,87 din camera
 *  de zi, și un apartament scăzut de la 81,10 la 80,50 m² utili. «When we
 *  increase the length of the balcony it should go on the outside, never on
 *  the inside of the apartment» (13.10.2026).
 *
 *  Deci pentru un spațiu de AFARĂ se alege zidul dincolo de care NU e nicio
 *  odaie. Pentru camerele dinăuntru rămâne capătul mare, ca până acum: acolo
 *  amândouă laturile dau în ceva, iar alegerea e doar o convenție. */
function cuZidulEi(plan: PlanTronson, c: Cota, zidAles?: number | null): Cota {
  const axa: 0 | 1 = Math.abs(c.b[0] - c.a[0]) >= Math.abs(c.b[1] - c.a[1]) ? 0 : 1;
  const alt = axa === 0 ? 1 : 0;
  const mij: Pt = [(c.a[0] + c.b[0]) / 2, (c.a[1] + c.b[1]) / 2];
  const camera = plan.camere.find((x) => inInel(mij, x.inel));
  const capete: { capat: Pt; spreB: boolean }[] = [
    { capat: c.b, spreB: c.b[axa] >= c.a[axa] },
    { capat: c.a, spreB: c.a[axa] >= c.b[axa] },
  ];
  // Pentru un spațiu de afară, capătul bun e cel dincolo de care nu e odaie.
  if (camera && AFARA.has(camera.kind)) {
    capete.sort((p, q) => Number(daInOdaie(plan, p.capat, axa, p.spreB))
                        - Number(daInOdaie(plan, q.capat, axa, q.spreB)));
  }
  // ZIDUL ALES BATE CONVENȚIA.
  //
  // Dintre cele două capete ale unei cote, oricare duce la un zid care, mutat,
  // schimbă cifra. Până acum alegea o convenție — capătul mare, sau cel
  // dinspre afară la un balcon —, iar pe un perete ales anume ea nimerea
  // adesea CELĂLALT zid: scrii cota ca să muți peretele pe care tocmai l-ai
  // apăsat, și pleacă altul. «If you select a wall and then you modify a cota
  // related to it, that should move that wall to change the dimension (the
  // selected one) not the other or a random one» (19.10.2026).
  //
  // Se încearcă deci ÎNTÂI capătul care duce chiar la zidul ales; dacă niciunul
  // nu duce la el, cota nu e a lui și rămâne convenția de dedesubt neatinsă —
  // altfel un zid ales undeva în plan ar fi furat cotele din tot modulul.
  if (zidAles != null) {
    for (const { capat, spreB } of capete) {
      if (zidulLaFata(plan, capat, axa, alt) !== zidAles) continue;
      return { ...c, muta: { axa, semn: spreB ? 1 : -1 },
               peZid: { i: zidAles, punct: [capat[0], capat[1]] } };
    }
  }
  for (const { capat, spreB } of capete) {
    const i = zidulLaFata(plan, capat, axa, alt);
    if (i == null) continue;
    return { ...c, muta: { axa, semn: spreB ? 1 : -1 },
             peZid: { i, punct: [capat[0], capat[1]] } };
  }
  return c;
}

/** Dincolo de capătul ăsta, în afara cotei, e o odaie (nu un spațiu de afară)? */
function daInOdaie(plan: PlanTronson, capat: Pt, axa: 0 | 1,
                   spreB: boolean): boolean {
  // Un pas peste zid: jumătate de metru trece de orice compartimentare și de
  // orice fațadă obișnuită, fără să sară peste o cameră îngustă.
  for (const pas of [0.35, 0.5, 0.7]) {
    const q: Pt = [capat[0], capat[1]];
    q[axa] += (spreB ? 1 : -1) * pas;
    const cam = plan.camere.find((x) => inInel(q, x.inel));
    if (cam) return !AFARA.has(cam.kind);
  }
  return false;
}

/** Zidul a cărui față cade pe punctul dat, pe axa dată. */
function zidulLaFata(plan: PlanTronson, p: Pt, axa: 0 | 1,
                     alt: 0 | 1): number | null {
  let cel: number | null = null;
  let celD = 0.08;                       // 8 cm: cât se abate o față rotunjită
  for (let k = 0; k < plan.pereti.length; k++) {
    const cut = cutiaInelului(plan.pereti[k].inel);
    const lo = axa === 0 ? cut.x0 : cut.y0;
    const hi = axa === 0 ? cut.x1 : cut.y1;
    // zidul trebuie să fie PERPENDICULAR pe cotă: subțire pe axa ei
    if (hi - lo > 1.0) continue;
    const l2 = alt === 0 ? cut.x0 : cut.y0;
    const h2 = alt === 0 ? cut.x1 : cut.y1;
    if (p[alt] < l2 - 0.15 || p[alt] > h2 + 0.15) continue;
    const d = Math.min(Math.abs(p[axa] - lo), Math.abs(p[axa] - hi));
    if (d < celD) { celD = d; cel = k; }
  }
  return cel;
}

// ------------------------------------------------- cotele de lucru ---

/** Cutia axială a unei piese rotite. */
export function cutiaPiesei(f: { c: Pt; w: number; h: number; deg: number }): Cutie {
  const r = (f.deg * Math.PI) / 180;
  const cs = Math.abs(Math.cos(r));
  const sn = Math.abs(Math.sin(r));
  const w = f.w * cs + f.h * sn;
  const h = f.w * sn + f.h * cs;
  return { x0: f.c[0] - w / 2, y0: f.c[1] - h / 2, x1: f.c[0] + w / 2, y1: f.c[1] + h / 2 };
}

const cutiaInelului = (ring: readonly Pt[]): Cutie => {
  const xs = ring.map((p) => p[0]);
  const ys = ring.map((p) => p[1]);
  return { x0: Math.min(...xs), y0: Math.min(...ys),
           x1: Math.max(...xs), y1: Math.max(...ys) };
};

/** Cât de departe se caută un obstacol. Peste atât, un obiect n-are «vecin» în
 *  direcția aia — e în mijlocul unui spațiu, și cota ar traversa tot modulul. */
const RAZA_CAUTARE = 12;

/** Cât se umflă un obiect fără grosime ca să aibă o bandă de aruncat: un gol
 *  e un segment între tocuri, o priză e un punct. Un centimetru — atât cât
 *  banda să existe, nu cât să prindă altceva decât ce e chiar în dreptul ei. */
const SUBTIRE = 0.01;

/** CUTIA OBIECTULUI ALES, cum o simte mâna care l-ar împinge — și, când
 *  obiectul se poate duce doar într-o direcție, pe care anume.
 *
 *  Toate obiectele planșei răspund la fel de bine, fiindcă toate au un loc și
 *  o întindere; ce le deosebește e doar de unde se citesc. `null` pentru cele
 *  care NU se măsoară așa:
 *
 *    * CAMERA — ea nu stă lângă ziduri, ea e golul dintre ele (v. antetul lui
 *      `editor/camere.ts`). Toate cele patru distanțe ar fi zero, iar cifrele
 *      pe care le vrea cineva care apasă pe o cameră sunt laturile ei, pe care
 *      planșa le scrie deja;
 *    * CONTURUL și NUCLEUL ÎNTREG — sunt cadrul în care stă restul, nu un
 *      obiect care are vecini.
 *
 *  `doarAxa` E PENTRU GOLURI ȘI PENTRU DOZE, și e o măsură de onestitate: o
 *  ușă alunecă pe zidul ei și nicăieri altundeva (v. `model::mutaObiectul`),
 *  iar doza la fel (v. `deALungulDozei`). Distanța de-a
 *  curmezișul — până la canapeaua din camera de dincolo — e adevărată, dar nu e
 *  a nimănui: scrisă în culoarea obiectului pe care tocmai îl muți, ar fi o
 *  cifră care arată că se poate schimba și care nu se schimbă. Rămâne deci
 *  doar lungul zidului, unde cifra și mâna spun același lucru. */
export function cutiaAlesului(
  plan: PlanTronson, ales: Ales,
): { cutie: Cutie; doarAxa?: 0 | 1 } | null {
  if (!ales) return null;
  if (ales.fel === "mobila") {
    const f = plan.piese[ales.i];
    return f ? { cutie: cutiaPiesei(f) } : null;
  }
  if (ales.fel === "perete") {
    const w = plan.pereti[ales.i];
    return w ? { cutie: cutiaInelului(w.inel) } : null;
  }
  if (ales.fel === "gol") {
    // Golul se recunoaște după lista din care vine și după locul lui în ea —
    // aceeași pereche pe care o scrie și desenul când îl alege.
    const fel = ales.fel2 === "doors" ? "usa" : "fereastra";
    const g = plan.goluri.find((x) => x.fel === fel && x.idx === ales.i);
    if (!g) return null;
    // DE-A CURMEZIȘUL, CÂT ZIDUL: golul e o tăietură în perete, iar banda cu
    // care se caută de-a lungul lui trebuie să fie chiar secțiunea zidului.
    // Umflat cu un fir de păr, golă cum vine din tocuri, ar fi căutat pe o
    // fâșie de doi centimetri și n-ar fi găsit colțul de care se cotează.
    const lung: 0 | 1 = Math.abs(g.b[0] - g.a[0]) >= Math.abs(g.b[1] - g.a[1])
      ? 0 : 1;
    const jum = grosimeaGazdei(plan, g) / 2;
    const c = cutiaInelului([g.a, g.b]);
    return {
      cutie: lung === 0 ? { ...c, y0: c.y0 - jum, y1: c.y1 + jum }
                        : { ...c, x0: c.x0 - jum, x1: c.x1 + jum },
      doarAxa: lung,
    };
  }
  if (ales.fel === "aparat") {
    const a = plan.electrice.find((x) => x.idx === ales.i);
    if (!a) return null;
    const cutie = umflata({ x0: a.c[0], y0: a.c[1],
                            x1: a.c[0], y1: a.c[1] }, SUBTIRE);
    // A box only measures along its wall (v. `coteleDozeiAlese`).
    if (a.kind === "doza" && gazdaDozei(plan, a)) {
      return { cutie, doarAxa: Math.abs(Math.sin((a.deg * Math.PI) / 180)) > 0.5
        ? 0 : 1 };
    }
    return { cutie };
  }
  if (ales.fel === "nucleuParte") {
    const p = plan.nucleu?.parti[ales.i];
    return p ? { cutie: cutiaInelului(p.inel) } : null;
  }
  return null;
}

/** GROSIMEA ZIDULUI ÎN CARE STĂ GOLUL.
 *
 *  Se caută GEOMETRIC, nu pe nume. Într-o planșă importată zidurile vin deja
 *  tăiate la goluri, iar `wall` numește un ciot de alături — pe M1, 14 din 16
 *  goluri au mijlocul în afara zidului al cărui nume îl poartă. Numele rămâne
 *  a doua încercare, fiindcă golurile PUSE de editor și-l scriu corect, iar
 *  peretele lor poate fi subțire cât să nu-i cuprindă centrul rotunjit. */
function grosimeaGazdei(plan: PlanTronson, g: { c: Pt; perete: string | null }):
  number {
  for (const w of plan.pereti) {
    const c = cutiaInelului(w.inel);
    if (g.c[0] >= c.x0 - 1e-6 && g.c[0] <= c.x1 + 1e-6
        && g.c[1] >= c.y0 - 1e-6 && g.c[1] <= c.y1 + 1e-6) return w.grosime;
  }
  const dupaNume = plan.pereti.find((w) => w.id === g.perete);
  return dupaNume?.grosime ?? 0.25;
}

/** Cutia, mărită cu `d` în toate părțile. */
const umflata = (c: Cutie, d: number): Cutie =>
  ({ x0: c.x0 - d, y0: c.y0 - d, x1: c.x1 + d, y1: c.y1 + d });

/** TOT CE POATE STA ÎN CALEA OBIECTULUI ALES: zidurile, piesele de mobilier și
 *  bucățile nucleului — cutiile lor —, mai puțin el însuși.
 *
 *  CE SE SUPRAPUNE PESTE EL NU E OBSTACOL, și asta nu se scrie aici: socoteala
 *  de mai jos sare peste orice distanță negativă sau nulă. De-acolo vine, pe
 *  gratis, răspunsul corect pentru obiectele care stau ÎN altceva — ușa e în
 *  zidul ei, priza e pe fața lui — și pentru foile lipite ale unei fațade: nu
 *  opresc măsura, deci cota trece prin ele până la primul lucru de care chiar
 *  s-ar lovi. */
function obstacolele(plan: PlanTronson, ales: Ales): Cutie[] {
  const out: Cutie[] = [];
  plan.pereti.forEach((w, j) => {
    if (ales?.fel === "perete" && j === ales.i) return;
    out.push(cutiaInelului(w.inel));
  });
  // UN PERETE SE MĂSOARĂ FAȚĂ DE ZIDĂRIE, NU FAȚĂ DE MOBILĂ.
  //
  // Cerut anume: «când dau click pe perete desenează-mi cu albastru cote față
  // de alți pereți, nu mă interesează cotele față de obiecte de mobilier».
  //
  // Și e convenția planșei, nu doar o preferință: cotele unui perete sunt cele
  // de TRASARE — după ele se zidește pe șantier, iar mobila nu se trasează. Un
  // perete care își spunea distanța până la canapeaua din fața lui scria o
  // măsură pe care n-o poate folosi nimeni, și o scria de patru ori, fiindcă
  // mobila e peste tot: pe M1, dintre cele 49 de piese, prima care iese în
  // calea unui zid e de obicei la o palmă de el.
  //
  // BUCĂȚILE NUCLEULUI RĂMÂN: scara și liftul sunt construite, se trasează, și
  // un perete chiar se poziționează față de ele.
  // A box is traced like a wall, not placed like furniture: its scan (the
  // no-host fallback) measures to masonry only.
  const doza = ales?.fel === "aparat"
    && plan.electrice.find((x) => x.idx === ales.i)?.kind === "doza";
  if (ales?.fel !== "perete" && !doza) {
    plan.piese.forEach((f, j) => {
      if (ales?.fel === "mobila" && j === ales.i) return;
      out.push(cutiaPiesei(f));
    });
  }
  (plan.nucleu?.parti ?? []).forEach((p, j) => {
    if (ales?.fel === "nucleuParte" && j === ales.i) return;
    out.push(cutiaInelului(p.inel));
  });
  return out;
}

/** DISTANȚELE DE LA OBIECTUL ALES LA PRIMUL OBSTACOL, în cele patru direcții.
 *
 *  Pe fiecare direcție se aruncă o BANDĂ cât latura obiectului, nu o rază din
 *  centru: ce contează e ce lovește el dacă e împins încolo. Obstacolele sunt
 *  pereții, piesele de mobilier și bucățile nucleului (v. `obstacolele`). Când
 *  în bandă cad mai multe obstacole la distanțe diferite — o noptieră pe
 *  jumătate din lățimea patului și zidul pe cealaltă jumătate —, se scrie o
 *  cotă pentru FIECARE porțiune de bandă cu alt prim-obstacol, la mijlocul
 *  porțiunii. Cel mult trei pe direcție: a patra ar fi zgomot.
 */
export function coteleObiectului(plan: PlanTronson, ales: Ales, pxPerM?: number,
                                 lanturi?: readonly LantDoza[]): Cota[] {
  // A MOUNTING BOX measures along its wall only (the architect's «cote din
  // pereții laterali până în ax»): its two chain segments, to the nearest
  // neighbour on each side. Off every wall it falls back to the scan below.
  if (ales?.fel === "aparat") {
    const e = plan.electrice.find((x) => x.idx === ales.i);
    if (e?.kind === "doza") {
      const doza = coteleDozeiAlese(plan, e, pxPerM, lanturi);
      if (doza) return doza;
    }
  }
  const tinta = cutiaAlesului(plan, ales);
  if (!tinta) return [];
  const B = tinta.cutie;
  const obstacole = obstacolele(plan, ales);
  const out: Cota[] = [];

  // Directia e dată de axa (0 = x, 1 = y) și de semn; banda e pe cealaltă axă.
  for (const [axa, semn] of [[0, -1], [0, 1], [1, -1], [1, 1]] as const) {
    if (tinta.doarAxa != null && axa !== tinta.doarAxa) continue;
    const alt = axa === 0 ? 1 : 0;
    const lo = (c: Cutie, ax: number) => (ax === 0 ? c.x0 : c.y0);
    const hi = (c: Cutie, ax: number) => (ax === 0 ? c.x1 : c.y1);
    const fata = semn < 0 ? lo(B, axa) : hi(B, axa);        // fața piesei
    const banda: [number, number] = [lo(B, alt), hi(B, alt)];

    type Ob = { d: number; i0: number; i1: number };
    const gasite: Ob[] = [];
    for (const o of obstacole) {
      const i0 = Math.max(banda[0], lo(o, alt));
      const i1 = Math.min(banda[1], hi(o, alt));
      if (i1 - i0 <= 0.01) continue;
      const d = semn < 0 ? fata - hi(o, axa) : lo(o, axa) - fata;
      // Ce e lipit sau se suprapune nu e «la distanță»; ce e prea departe nu
      // e vecin.
      if (d < 0.005 || d > RAZA_CAUTARE) continue;
      gasite.push({ d, i0, i1 });
    }
    gasite.sort((p, q) => p.d - q.d);

    // Porțiunile de bandă deja acoperite de un obstacol mai apropiat.
    const acoperite: [number, number][] = [];
    const runuri: { d: number; i0: number; i1: number }[] = [];
    for (const o of gasite) {
      // ce rămâne din [i0, i1] după scăderea acoperitelor
      let ramase: [number, number][] = [[o.i0, o.i1]];
      for (const [a0, a1] of acoperite) {
        const urm: [number, number][] = [];
        for (const [r0, r1] of ramase) {
          if (a1 <= r0 || a0 >= r1) { urm.push([r0, r1]); continue; }
          if (a0 > r0) urm.push([r0, a0]);
          if (a1 < r1) urm.push([a1, r1]);
        }
        ramase = urm;
      }
      // O FÂȘIE nu primește cotă: cei 10 cm dintre noptieră și colțul zidului
      // ar scrie încă o distanță până la zid, adevărată și inutilă. Pragul e
      // relativ la lățimea benzii — o piesă lată are fâșii mai late.
      //
      // DAR NICIODATĂ MAI LAT DECÂT BANDA. Podeaua de 15 cm a pragului era
      // scrisă pentru mobilier, unde orice piesă e mai lată de-atât. Un GOL
      // văzut de-a lungul zidului lui are banda cât grosimea peretelui — 10 cm
      // pe o compartimentare —, deci nicio fâșie n-o putea trece și ușa nu-și
      // afla distanța până la colț, singura pe care o poate și schimba. Cu
      // plafonul, obiectele subțiri își capătă cotele, iar pentru orice bandă
      // de peste 17 cm pragul rămâne cel dinainte.
      const lat = banda[1] - banda[0];
      const fasie = Math.min(Math.max(0.15, 0.1 * lat), 0.9 * lat);
      for (const r of ramase) {
        if (r[1] - r[0] > fasie) runuri.push({ d: o.d, i0: r[0], i1: r[1] });
      }
      acoperite.push([o.i0, o.i1]);
      // Banda e toată acoperită: ce urmează e în spatele a ceva.
      if (acoperita(banda, acoperite)) break;
    }
    runuri.sort((p, q) => (q.i1 - q.i0) - (p.i1 - p.i0));
    // ACEEAȘI DISTANȚĂ SE SCRIE O DATĂ ȘI AICI — regula 5, pe măsurile de
    // lucru. O noptieră pusă la mijlocul laturii taie banda în trei: noptiera,
    // și zidul de deasupra și de dedesubtul ei, la fel de departe amândouă.
    // «1,00» de două ori pe aceeași parte nu spune de două ori ceva: rămâne
    // porțiunea cea mai lată, deci prima din lista sortată.
    const spuse = new Set<string>();
    const alese = runuri.filter((r) => {
      const cifra = r.d.toFixed(2);
      if (spuse.has(cifra)) return false;
      spuse.add(cifra);
      return true;
    });
    for (const r of alese.slice(0, 3)) {
      const m = (r.i0 + r.i1) / 2;
      const p0: Pt = axa === 0 ? [fata, m] : [m, fata];
      const p1: Pt = axa === 0 ? [fata + semn * r.d, m] : [m, fata + semn * r.d];
      // Axa și sensul merg CU cota: ele sunt tot ce-i trebuie cifrei ca să
      // poată fi scrisă în loc de doar citită — v. `Cota::muta`.
      out.push({ a: p0, b: p1, valoare: r.d, muta: { axa, semn } });
    }
  }
  return out;
}

/** Intervalul e acoperit în întregime de reuniunea celor date? */
function acoperita(b: [number, number], parti: [number, number][]): boolean {
  const s = [...parti].sort((p, q) => p[0] - q[0]);
  let t = b[0];
  for (const [a0, a1] of s) {
    if (a0 > t + 1e-9) return false;
    t = Math.max(t, a1);
    if (t >= b[1] - 1e-9) return true;
  }
  return t >= b[1] - 1e-9;
}

/** Numele camerelor și ariile lor, ca dreptunghiuri ocupate — ce primește
 *  `cotelePlanului` ca să nu scrie peste ele. `h` e corpul literei în metri,
 *  `randuri` câte rânduri are eticheta. */
export function cutiaEtichetei(cx: number, cy: number, h: number, latime: number,
                               randuri: number): Cutie {
  const w = latime;
  const ht = h * (randuri === 2 ? 2.1 : 1.2);
  return { x0: cx - w / 2, y0: cy - ht / 2, x1: cx + w / 2, y1: cy + ht / 2 };
}

/** CÂT E UȘA ALEASĂ — nu unde stă.
 *
 *  Celelalte cote de lucru ale unui gol măsoară DISTANȚE: de la ușă până la
 *  colț, până la dulap (v. `coteleObiectului`). Niciuna nu spune ușa însăși,
 *  și tocmai asta se caută cel mai des pe o planșă: «1,03/2,10» — golul din
 *  zid pe înălțimea lui. Se scrie GOLUL, nu lumina, fiindcă golul e ce se
 *  execută: zidarul lasă spărtura, tâmplarul îi pune tocul înăuntru.
 *
 *  ÎNĂLȚIMEA VINE CU EA, după bară, fiindcă e singura măsură a ușii pe care
 *  desenul în plan n-o poate arăta niciodată — o secțiune orizontală taie pe
 *  la un metru și nu știe nimic despre ce e deasupra.
 *
 *  STĂ ÎN PARTEA ÎN CARE NU BALEIAZĂ FOAIA: arcul ocupă un sfert de cerc cât
 *  toată lumina ușii, iar o linie de cotă peste el nu se mai citește nici ea,
 *  nici arcul. `departare` e cât se duce dincolo de fața zidului, în metri —
 *  o vine de la desen, care singur știe mărirea (o cotă e o adnotare: aceiași
 *  pixeli la orice zoom).
 *
 *  `null` pentru orice altceva decât o ușă: o fereastră are și parapet, deci
 *  cifrele ei nu sunt două, iar un perete sau o priză n-au «gol».
 *
 *  ACEEAȘI COTĂ O PRIMEȘTE ORICE UȘĂ, aleasă sau nu (regula 10) — aici e doar
 *  poarta dinspre selecție spre `cotaUsii`. */
export function cotaGolului(plan: PlanTronson, ales: Ales,
                            departare: number): Cota | null {
  if (ales?.fel !== "gol") return null;
  // ȘI FERESTRELE, de pe 21.10.2026: cifra se cerea ca să se vadă cât TRAGI de
  // capătul unei ferestre, iar aici era oprită. Planșa cotează mai departe
  // numai ușile (regula 10, v. `cotelePlanului`) — asta e poarta dinspre
  // SELECȚIE, și ea răspunde despre orice gol ales.
  const felul = ales.fel2 === "doors" ? "usa" : "fereastra";
  const g = plan.goluri.find((x) => x.fel === felul && x.idx === ales.i);
  return g ? cotaUsii(plan, g, departare) : null;
}

/** Cota unei uși anume — socoteala descrisă mai sus, pe golul primit. */
/** TOLERANȚA pe care se recunosc două ziduri ca fiind pe ACEEAȘI linie, în
 *  metri. 5 mm: mai mult decât slăbiciunea transcrierii și decât rotunjirea la
 *  milimetru a editorului, mai puțin decât orice decalaj pe care l-ar desena
 *  cineva dinadins. */
const TOL_LINIE = 0.005;

/** CÂT DE LARG POATE FI UN GOL ÎNTRE DOUĂ ZIDURI ca să fie încă o arcadă:
 *  2,50 m. Peste atât nu mai e un gol în perete, sunt DOUĂ PEREȚI.
 *
 *  MĂSURAT PE TOT CATALOGUL (46 de module, versiunea cea mai nouă a fiecăruia,
 *  21.10.2026), fiindcă regula fără prag se purta rău: colineare, de aceeași
 *  grosime și fără ușă în ele sunt 723 de întreruperi, cu lățimi de la 0,05 m
 *  la 52,26 m — adică și fața de nord cu fața de sud a aceluiași ax, care n-au
 *  între ele decât tot modulul. ȘI NU EXISTĂ PRĂPASTIE ÎN CIFRE pe care s-o
 *  urmezi: distribuția e continuă, cel mai mare salt (13,1 m) cade sus, între
 *  36,4 și 49,5, adică între două absurdități. Deci pragul vine din ce ESTE un
 *  gol de perete, nu din unde se rărește șirul.
 *
 *  2,50 fiindcă peste atât golul cere o grindă, nu un buiandrug — iar pe planul
 *  unei locuințe un gol de trei metri într-un zid nu e o arcadă, e un perete
 *  care lipsește. Cifra se potrivește și cu numărătoarea făcută separat, pe
 *  ochi, a arcadelor adevărate: la pragul ăsta ies 345 de goluri pe 46 de
 *  module, adică 7,5 pe modul, iar pe M1 fuseseră numărate 6 arcade adevărate
 *  și pe M5 opt. */
const GOL_INTRE_ZIDURI_MAX = 2.5;

/** Un zid drept, citit pe axele lui: `axa` e cea pe care e SUBȚIRE (coordonata
 *  fixă), `s0..s1` întinderea pe lungul lui. */
type ZidDrept = {
  i: number; axa: 0 | 1;
  f0: number; f1: number;      // cele două fețe, pe axa subțire
  s0: number; s1: number;      // capetele, pe axa lungă
};

function zidDrept(inel: readonly Pt[], i: number): ZidDrept | null {
  if (inel.length < 3) return null;
  const xs = inel.map((q) => q[0]), ys = inel.map((q) => q[1]);
  const x0 = Math.min(...xs), x1 = Math.max(...xs);
  const y0 = Math.min(...ys), y1 = Math.max(...ys);
  const lx = x1 - x0, ly = y1 - y0;
  if (!(lx > 0) || !(ly > 0)) return null;
  // SUBȚIRIMEA hotărăște care axă e care: un zid e mai lung decât e gros.
  return lx <= ly
    ? { i, axa: 0, f0: x0, f1: x1, s0: y0, s1: y1 }
    : { i, axa: 1, f0: y0, f1: y1, s0: x0, s1: x1 };
}

/** GOLURILE DINTRE DOUĂ ZIDURI COLINEARE — adică arcadele planșei.
 *
 *  DE CE E UN GOL, ȘI NU DOUĂ ZIDURI. Două bucăți de zid pe aceeași linie, cu
 *  aceeași grosime, despărțite de o întrerupere în care nu stă nicio ușă și
 *  nicio fereastră, SUNT o arcadă — fie că omul a desenat două ziduri cu un
 *  rost între ele, fie că a spart unul cu unealta de spargere
 *  (`model::demoleazaBucata`, care chiar taie zidul în două). Documentul nu
 *  păstrează nimic care să le deosebească, și tocmai de-aia nu trebuie
 *  deosebite: ce se vede pe planșă e un gol în perete.
 *
 *  FĂRĂ UȘĂ ȘI FĂRĂ FEREASTRĂ ÎN EL, și asta nu e un amănunt, e chiar ce ține
 *  regula în picioare: o ușă stă ea însăși într-o întrerupere a zidului, iar
 *  măsura ei e DEJA scrisă pe planșă (regula 10). Fără paza asta, fiecare ușă
 *  și-ar fi căpătat cifra a doua oară — pe M1, din 24 de goluri colineare 18
 *  sunt uși, pe M5 din 43 sunt 35.
 *
 *  ACEEAȘI GROSIME, pe amândouă fețele: două ziduri de grosimi diferite care se
 *  întâlnesc cap la cap nu sunt un zid rupt, sunt două ziduri, iar «golul»
 *  dintre ele e locul unde se schimbă peretele.
 */
export function golurileDintreZiduri(
  plan: { pereti: readonly { inel: Pt[]; bulge?: number }[];
          goluri: readonly { c: Pt }[] },
): { a: Pt; b: Pt; latime: number; grosime: number }[] {
  const drepte: ZidDrept[] = [];
  plan.pereti.forEach((w, i) => {
    if (w.bulge) return;                       // un zid curb n-are axă lungă
    const z = zidDrept(w.inel, i);
    if (z) drepte.push(z);
  });
  const out: { a: Pt; b: Pt; latime: number; grosime: number }[] = [];
  const vazute = new Set<string>();
  for (let p = 0; p < drepte.length; p++) {
    for (let q = p + 1; q < drepte.length; q++) {
      const A = drepte[p], B = drepte[q];
      if (A.axa !== B.axa) continue;
      // ACEEAȘI LINIE ȘI ACEEAȘI GROSIME dintr-o singură întrebare: fețele
      // cad una peste alta.
      if (Math.abs(A.f0 - B.f0) > TOL_LINIE
          || Math.abs(A.f1 - B.f1) > TOL_LINIE) continue;
      // se ating ori se suprapun? atunci nu e nicio întrerupere
      const de = Math.min(A.s1, B.s1), la = Math.max(A.s0, B.s0);
      if (la - de <= TOL_LINIE) continue;
      if (la - de > GOL_INTRE_ZIDURI_MAX) continue;      // doi pereți, nu un gol
      const mij = (A.f0 + A.f1) / 2;
      const pct = (t: number): Pt => (A.axa === 0 ? [mij, t] : [t, mij]);
      // O UȘĂ SAU O FEREASTRĂ ÎN GOL îl scoate din socoteală: măsura ei e deja
      // pe planșă.
      const ocupat = plan.goluri.some((g) => {
        const t = A.axa === 0 ? g.c[1] : g.c[0];
        const n = A.axa === 0 ? g.c[0] : g.c[1];
        return t > de - TOL_LINIE && t < la + TOL_LINIE
            && n > A.f0 - TOL_LINIE && n < A.f1 + TOL_LINIE;
      });
      if (ocupat) continue;
      // ÎNTRERUPEREA TREBUIE SĂ FIE GOALĂ — de ORICE zid, nu doar de unul de pe
      // aceeași linie, iar asta se întreabă pe MIJLOCUL ei. Două cazuri, și
      // amândouă s-au văzut pe planuri adevărate:
      //
      //   * un rând de TREI bucăți pe aceeași linie: «golul» dintre prima și a
      //     treia e de fapt a doua, deci un perete tăiat de două arcade ar fi
      //     căpătat și o a treia cotă, peste amândouă, cât tot zidul;
      //   * o ÎMBINARE ÎN T sau în cruce: zidul care trece perpendicular rupe
      //     linia, iar «golul» rămas e exact grosimea lui — plin de zidărie, nu
      //     un gol. Pe M1 și pe M5 așa ieșeau câte trei goluri de 0,30 m, adică
      //     chiar grosimea pereților care le tăiau. Guardul de dinainte întreba
      //     numai de zidurile COLINEARE, deci nu le vedea.
      //
      //  Mijlocul e de ajuns, și e și cel potrivit: o îmbinare umple tocmai
      //  mijlocul (golul e cât zidul care trece), în timp ce un zid care se
      //  OPREȘTE la marginea unei arcade adevărate lasă mijlocul liber.
      const mijlocul: Pt = pct((de + la) / 2);
      if (plan.pereti.some((w, idx) => idx !== A.i && idx !== B.i
                                    && inInel(mijlocul, w.inel))) continue;
      // O PERECHE, O DATĂ: două perechi care arată același gol se strâng
      // într-una, pe geometria lui.
      const cheie = `${A.axa}|${Math.round(mij * 1000)}|`
        + `${Math.round(de * 1000)}|${Math.round(la * 1000)}`;
      if (vazute.has(cheie)) continue;
      vazute.add(cheie);
      out.push({ a: pct(de), b: pct(la), latime: la - de,
                 grosime: A.f1 - A.f0 });
    }
  }
  return out;
}

/** CÂT E O ARCADĂ, scrisă lângă ea — sora lui `cotaUsii`, pentru un gol care
 *  n-are foaie.
 *
 *  AMÂNDOUĂ PĂRȚILE SE ÎNCEARCĂ, și de-aia primește `semn`. O ușă are o parte
 *  bună dinainte — cea opusă baleiajului, unde foaia nu trece peste cifră —, dar
 *  o arcadă n-are foaie, deci n-are nici parte bună: contează doar unde ÎNCAPE.
 *  Măsurat pe planul real: spărtura de 0,85 m cade chiar în dreptul unui zid
 *  perpendicular, deci pe partea dinspre el cifra intra în hașură la toate trei
 *  depărtările și cota se pierdea cu totul — pe partea cealaltă încape.
 *
 *  ORDINEA E AȘEZATĂ, nu la întâmplare: se încearcă întâi `-1`, ca o arcadă
 *  care încape pe amândouă părțile să-și pună cifra mereu în același loc și
 *  desenul să nu sară de la o redesenare la alta.
 *
 *  `masurat` E GOLUL, nu linia cotei: cheia cu care se stinge o cotă de pe
 *  planșă se ia de-acolo (v. `cheiaCotei`), iar linia se mută cu depărtarea
 *  aleasă, care ține de MĂRIRE. Luată de pe linie, cheia s-ar fi schimbat de la
 *  o mărire la alta, iar o cotă stinsă s-ar fi întors la primul zoom. */
/** TRECE LINIA COTEI PRIN VREUN ZID? Măsurat pe puncte de-a lungul ei, nu pe
 *  capete: un zid poate fi străbătut prin mijloc, fără să cuprindă niciun
 *  capăt al liniei.
 *
 *  PRAGUL E O ȘESPRE: sub atât, linia doar atinge un colț — la capătul ei stă
 *  oricum fața unui perete, deci zero ar fi fost imposibil. Aceeași măsură o
 *  face și proba de pe catalog, ca ce se cere și ce se verifică să fie un
 *  singur lucru. */
/** SPUNE COTA `c` CE E DEJA SCRIS ALĂTURI? — regula 5, dar pe COTE, nu pe fețe.
 *
 *  DE CE NU AJUNGE `scrisaDeja`. Ea compară FEȚE de zid, iar fața unei arcade
 *  stă pe AXUL peretelui, nu pe fața lui: o cotă de cameră ori de ușă cu aceeași
 *  cifră, la o jumătate de grosime, nu-i făcea punte și-i scăpa. Pe M1, la
 *  60 px/m, așa ieșea «1,60» de două ori lângă hol.
 *
 *  DEPĂRTAREA PÂNĂ LA CARE OCHIUL LE IA ÎMPREUNĂ: zidul cel mai gros din
 *  catalog (45 cm) plus cele două depărtări de față. Peste atât sunt două cifre
 *  în două locuri; sub, sunt aceeași cifră scrisă de două ori.
 *
 *  SE ÎNTREABĂ NUMAI PENTRU ARCADE, și asta nu e o scăpare: o arcadă e o cifră
 *  ÎN PLUS, deci la îndoială se tace. Cotele pe care planșa le datorează —
 *  conturul, ușile, camerele — trec mai departe prin regula 5 pe fețe, unde ele
 *  chiar au fețe. */
function ecouScris(c: Cota, scrise: readonly Cota[], k: number): boolean {
  const u = (x: Cota): Pt => {
    const L = Math.hypot(x.b[0] - x.a[0], x.b[1] - x.a[1]) || 1;
    return [(x.b[0] - x.a[0]) / L, (x.b[1] - x.a[1]) / L];
  };
  const [ux, uy] = u(c);
  const peLung = (p: Pt) => p[0] * ux + p[1] * uy;
  const deoparte = (p: Pt) => -p[0] * uy + p[1] * ux;
  const [a0, a1] = [Math.min(peLung(c.a), peLung(c.b)),
                    Math.max(peLung(c.a), peLung(c.b))];
  const prag = 0.45 + (2 * COTA_PX.afara) / k + 0.02;
  return scrise.some((d) => {
    if (Math.abs(d.valoare - c.valoare) > TOL_CIFRA) return false;
    const [vx, vy] = u(d);
    if (Math.abs(ux * vy - uy * vx) > 1e-3) return false;      // nu-s paralele
    const [b0, b1] = [Math.min(peLung(d.a), peLung(d.b)),
                      Math.max(peLung(d.a), peLung(d.b))];
    if (Math.min(a1, b1) - Math.max(a0, b0)
        < 0.8 * Math.min(c.valoare, d.valoare)) return false;  // nu se acoperă
    return Math.abs(deoparte(c.a) - deoparte(d.a)) <= prag;
  });
}

function prinZid(c: Cota, plan: PlanTronson): boolean {
  const N = 40;
  let inZid = 0;
  for (let q = 1; q < N; q++) {
    const t = q / N;
    const x = c.a[0] + (c.b[0] - c.a[0]) * t;
    const y = c.a[1] + (c.b[1] - c.a[1]) * t;
    if (plan.pereti.some((w) => !w.subTaietura && inInel([x, y], w.inel))) inZid++;
  }
  return inZid > 0.15 * N;
}

function cotaArcadei(g: { a: Pt; b: Pt; latime: number }, grosime: number,
                     departare: number, semn: 1 | -1): Cota | null {
  const L = Math.hypot(g.b[0] - g.a[0], g.b[1] - g.a[1]);
  if (!(L > 0)) return null;
  const nx = -(g.b[1] - g.a[1]) / L;
  const ny = (g.b[0] - g.a[0]) / L;
  const d = (grosime / 2 + departare) * semn;
  return {
    a: [g.a[0] + nx * d, g.a[1] + ny * d],
    b: [g.b[0] + nx * d, g.b[1] + ny * d],
    valoare: g.latime,
    masurat: [[g.a[0], g.a[1]], [g.b[0], g.b[1]]],
  };
}

/** PAZA «NUMAI UȘI» A PLECAT DE AICI, pe 21.10.2026, fiindcă era în două
 *  locuri: lanțul planșei filtrează oricum ușile înainte să cheme (regula 10,
 *  v. `cotelePlanului`), iar paza dinăuntru oprea singurul alt chemător —
 *  `cotaGolului`, prin care un gol ALES își scrie măsura. De-aia o fereastră
 *  trasă de capăt nu arăta nicio cifră: regula lucra, dar răspunsul era oprit
 *  la ușă. Ce gol capătă cifră PE PLANȘĂ se hotărăște acolo unde se alege, nu
 *  aici. */
export function cotaUsii(plan: PlanTronson, g: Gol,
                         departare: number): Cota | null {
  const L = Math.hypot(g.b[0] - g.a[0], g.b[1] - g.a[1]);
  if (!(L > 0)) return null;
  const nx = -(g.b[1] - g.a[1]) / L;
  const ny = (g.b[0] - g.a[0]) / L;
  // Partea OPUSĂ baleiajului. Fără sens dedus (`spre` e null pe un gol care
  // nu dă în nicio cameră), rămâne partea normalei: o parte oarecare, dar
  // aceeași de fiecare dată, deci cota nu sare de colo-colo la reselectare.
  const spre = g.spre
    ? Math.sign((g.spre[0] - g.c[0]) * nx + (g.spre[1] - g.c[1]) * ny) || 1 : 1;
  const d = (grosimeaGazdei(plan, g) / 2 + departare) * -spre;
  return {
    a: [g.a[0] + nx * d, g.a[1] + ny * d],
    b: [g.b[0] + nx * d, g.b[1] + ny * d],
    valoare: g.latime,
    si: g.inaltime,
    masurat: [[g.a[0], g.a[1]], [g.b[0], g.b[1]]],
  };
}

/** CÂT DE DEPARTE DE UN GOL mai poate sta un zid ca să fie «cel care-l
 *  mărginește». Peste 12 m nu mai e un umăr de ușă, e capătul celălalt al
 *  modulului. */
const UMAR_MAX = 12;

/** COTELE CARE AȘAZĂ UN GOL ÎNTRE PEREȚII DE LÂNGĂ EL.
 *
 *  Cerut de arhitect (27.10.2026): «aș vrea ca atunci când selectez o
 *  ușă/fereastră să-mi arate cotele până în pereții celor 2 camere, să pot să
 *  modific cotele acelea și să-mi mute ușa/fereastra».
 *
 *  Planșa scria despre un gol doar LĂȚIMEA lui (regula 10, v. `cotaUsii`), iar
 *  unde ANUME stă el pe perete nu se putea nici citi, nici scrie: ușa se muta
 *  numai trăgând de ea. Astea sunt cele două măsuri cu care se așază o ușă pe
 *  hârtie — de la toc până în zidul din stânga, și până în cel din dreapta.
 *
 *  SE CAUTĂ ZIDURILE CARE CHIAR TAIE GAZDA, nu cele din apropiere: un zid e
 *  socotit „umăr" dacă banda lui se suprapune peste banda gazdei (deci chiar o
 *  întâlnește) și dacă stă dincolo de capătul golului. Din ele se ia cel mai
 *  APROPIAT de fiecare parte — el e peretele camerei.
 *
 *  SE SCRIU NUMAI PE ZIDURI DREPTE: `scrieCota` mută obiectul pe o axă a
 *  planului, iar pe un zid oblic o cifră scrisă ar fi dus ușa alături de
 *  perete. Pe unul oblic cotele nu se arată deloc — mai bine lipsă decât
 *  mincinoasă. */
export function coteleAsezariiGolului(
  plan: PlanTronson, ales: Ales, departare: number,
): Cota[] {
  if (ales?.fel !== "gol") return [];
  const felul = ales.fel2 === "doors" ? "usa" : "fereastra";
  const g = plan.goluri.find((x) => x.fel === felul && x.idx === ales.i);
  if (!g) return [];
  const L = Math.hypot(g.b[0] - g.a[0], g.b[1] - g.a[1]);
  if (!(L > 0)) return [];
  const ux = (g.b[0] - g.a[0]) / L;
  const uy = (g.b[1] - g.a[1]) / L;
  // NUMAI PE ORIZONTALĂ SAU PE VERTICALĂ — v. nota de mai sus.
  const axa: 0 | 1 | null = Math.abs(ux) > 1 - 1e-6 ? 0
    : Math.abs(uy) > 1 - 1e-6 ? 1 : null;
  if (axa === null) return [];
  const nx = -uy, ny = ux;
  const gros = grosimeaGazdei(plan, g);
  /** Cât de departe, de-a lungul zidului, socotit din `g.a`. */
  const t = (p: readonly number[]) => (p[0] - g.a[0]) * ux + (p[1] - g.a[1]) * uy;
  /** Cât de departe, de-a curmezișul lui, socotit din mijlocul golului. */
  const n = (p: readonly number[]) => (p[0] - g.c[0]) * nx + (p[1] - g.c[1]) * ny;

  /** UMERII GOLULUI: cât e până la cel mai apropiat lucru, de o parte și de
   *  alta, de-a lungul zidului. Cu `cuGoluri`, intră în socoteală și CELELALTE
   *  goluri de pe același perete — o ușă vecină, o fereastră —, nu doar
   *  zidurile. */
  const umerii = (cuGoluri: boolean, latura: 1 | -1) => {
    let stanga = -Infinity;    // fața cea mai apropiată dinspre `a`
    let dreapta = Infinity;    // …și dinspre `b`
    const incearca = (pts: readonly (readonly number[])[]) => {
      const ns = pts.map(n);
      const n0 = Math.min(...ns), n1 = Math.max(...ns);
      // Se atinge de banda gazdei? Altfel e altceva, care doar trece pe-aproape.
      if (n0 > gros / 2 + 1e-6) return;
      if (n1 < -gros / 2 - 1e-6) return;
      // FIECARE PARTE ARE PEREȚII EI, și asta e tot miezul cererii: un zid
      // care iese din banda gazdei PE LATURA ASTA mărginește odaia de pe
      // partea asta; unul care iese pe cealaltă n-are nicio treabă cu ea. Un
      // zid care rămâne ÎN bandă e colinear cu gazda — el mărginește
      // amândouă. Pe desenul arhitectei se vede limpede: sus 0,60 și 0,70,
      // jos 0,65 și 0,65, pentru ACEEAȘI ușă.
      const iese = latura > 0 ? n1 > gros / 2 + 1e-6 : n0 < -gros / 2 - 1e-6;
      const inBanda = n0 >= -gros / 2 - 1e-6 && n1 <= gros / 2 + 1e-6;
      if (!iese && !inBanda) return;
      const ts = pts.map(t);
      const t0 = Math.min(...ts), t1 = Math.max(...ts);
      if (t1 <= 1e-6 && t1 > stanga) stanga = t1;
      if (t0 >= L - 1e-6 && t0 < dreapta) dreapta = t0;
    };
    for (const w of plan.pereti) {
      if (w.id === g.perete) continue;
      incearca(w.inel);
    }
    if (cuGoluri) {
      for (const alt of plan.goluri) {
        if (alt === g) continue;
        incearca([alt.a, alt.b]);
      }
    }
    return { stanga, dreapta };
  };

  // PE CE PARTE SE SCRIU. Cerut de arhitect (27.10.2026): «aș vrea să-mi treacă
  // cotele pe partea corectă a peretelui (de exemplu aici ar fi trebuit să le
  // pună în interiorul camerei). Pe exterior ar putea să-mi arate distanțele
  // până la următoarele ferestre/pereți (...) similar ar trebui să fie și în
  // cazul ușilor: în partea de sus să afișeze cotele până în pereți și în
  // partea de jos (...) până în ușă (la stânga) și până în perete (la
  // dreapta)».
  //
  // Deci două rânduri, cu înțelesuri deosebite:
  //   ÎNĂUNTRU (partea camerei) — până în PEREȚI: cu ele se așază golul în
  //   odaia lui, și tot ele se scriu cel mai des.
  //   AFARĂ — până la cel mai apropiat LUCRU, fie el alt gol sau un zid: pe o
  //   fațadă, asta e distanța dintre ferestre.
  //
  // `g.spre` arată spre camera în care dă golul. Cota de lățime (regula 10) stă
  // pe partea cealaltă, ca să nu cadă peste baleiajul ușii; rândul de afară se
  // duce mai departe decât ea, ca cele două să nu se încalece.
  const spre = g.spre
    ? Math.sign((g.spre[0] - g.c[0]) * nx + (g.spre[1] - g.c[1]) * ny) || 1 : 1;
  /** Componenta lui `u` pe axa pe care se mută: ±1. */
  const comp = axa === 0 ? ux : uy;
  const out: Cota[] = [];
  const rand = (d: number, cuGoluri: boolean, latura: 1 | -1) => {
    const { stanga, dreapta } = umerii(cuGoluri, latura);
    const pe = (tt: number): Pt => [g.a[0] + ux * tt + nx * d,
                                    g.a[1] + uy * tt + ny * d];
    if (stanga > -Infinity && -stanga <= UMAR_MAX && -stanga > 1e-3) {
      out.push({
        a: pe(stanga), b: pe(0), valoare: -stanga, asezare: true,
        // CERUT MAI MARE = GOLUL PLEACĂ DE LÂNGĂ ce e în stânga, adică spre
        // `b`. `scrieCota` face `semn * (valoare − v)`, iar `v > valoare` dă un
        // număr negativ: semnul îl întoarce pe direcția lui `u`.
        muta: { axa, semn: (comp > 0 ? -1 : 1) as 1 | -1 },
        masurat: [[g.a[0] + ux * stanga, g.a[1] + uy * stanga],
                  [g.a[0], g.a[1]]],
      });
    }
    if (dreapta < Infinity && dreapta - L <= UMAR_MAX && dreapta - L > 1e-3) {
      out.push({
        a: pe(L), b: pe(dreapta), valoare: dreapta - L, asezare: true,
        // …și invers de partea cealaltă.
        muta: { axa, semn: (comp > 0 ? 1 : -1) as 1 | -1 },
        masurat: [[g.b[0], g.b[1]],
                  [g.a[0] + ux * dreapta, g.a[1] + uy * dreapta]],
      });
    }
  };
  // Fiecare rând se măsoară cu pereții DE PARTEA LUI (v. `umerii`).
  rand((gros / 2 + departare) * spre, false, spre as 1 | -1);
  rand((gros / 2 + departare * 2.4) * -spre, true, -spre as 1 | -1);
  return out;
}

/** THE HOST WALL OF A MOUNTING BOX: the wall whose ring passes through the
 *  box's centre (`lipitDeZid` puts the box on the face, so the distance is
 *  zero up to rounding) and whose edge there runs across the box's normal.
 *  A box dragged off every wall has no host: no depth cap and, later, no
 *  dimension chain. */
export function gazdaDozei(plan: PlanTronson,
                           e: { c: Pt; deg: number }): Perete | null {
  const rad = (e.deg * Math.PI) / 180;
  const n: Pt = [Math.cos(rad), Math.sin(rad)];
  let cel: { w: Perete; d: number } | null = null;
  for (const w of plan.pereti) {
    for (let i = 0; i < w.inel.length; i++) {
      const a = w.inel[i];
      const b = w.inel[(i + 1) % w.inel.length];
      const vx = b[0] - a[0], vy = b[1] - a[1];
      const L = Math.hypot(vx, vy);
      if (L < 1e-9) continue;
      // The edge the box sits on runs along the wall: across its normal.
      if (Math.abs((vx * n[0] + vy * n[1]) / L) > 0.105) continue;   // sin 6°
      const t = Math.max(0, Math.min(1, ((e.c[0] - a[0]) * vx + (e.c[1] - a[1]) * vy)
                                        / (L * L)));
      const d = Math.hypot(e.c[0] - a[0] - t * vx, e.c[1] - a[1] - t * vy);
      if (d <= 0.005 && (!cel || d < cel.d)) cel = { w, d };
    }
  }
  return cel?.w ?? null;
}

/** A mounting-box dimension chain: one wall face, one height, one family —
 *  drawn by `Desen` in the family's ink. Its spans may run in pieces, one on
 *  each side of a door. */
export type LantDoza = { fam: FamilieDoza; h: number; cote: Cota[] };

/** Every mark along one wall face where a box chain stops, in the face's
 *  frame (`s` along it, `v` into the room from it), by the side it closes:
 *  `stangi` ends a chain coming from its right, `drepte` one from its left.
 *  A box standing on a stop must keep the span on its open side, so one list
 *  would not do: a pointer in a doorway lands the box on the jamb.
 *  Found by geometry, never by a wall's id: the catalogue cuts its walls at
 *  openings (on M5, 27 of 30 openings have no wall of their own id at both
 *  jambs) and one room face runs over several segments.
 *  - the sides of a wall that reaches into the room past the face while
 *    touching it — not `coteleAsezariiGolului`'s band, which is centred on
 *    the axis and also counts walls on the far face (right for an opening cut
 *    through the wall, wrong for a box on one face);
 *  - the jambs of every opening, door or window, cut through the face: its
 *    axis runs along the face and its wall's band crosses it;
 *  - the wall band of an opening square to the face and ending at it: the
 *    catalogue cuts that wall there, so the opening is all that reaches the face;
 *  - the ends of the face itself: where the walls lying behind it stop, at a
 *    cut opening, a doorless passage or the wall's free end. */
function opririleFetei(plan: PlanTronson,
                       s: (p: Pt) => number, v: (p: Pt) => number):
    { stangi: number[]; drepte: number[] } {
  const stangi: number[] = [];
  const drepte: number[] = [];
  const fata: [number, number][] = [];
  for (const w of plan.pereti) {
    const vs = w.inel.map(v);
    if (Math.max(...vs) > 0.005) {
      if (Math.min(...vs) > 0.005) continue;   // floats off this face
      const ts = w.inel.map(s);
      stangi.push(Math.max(...ts));
      drepte.push(Math.min(...ts));
      continue;
    }
    // Behind the face: its edges on the face line are the face.
    for (let i = 0; i < w.inel.length; i++) {
      const a = w.inel[i];
      const b = w.inel[(i + 1) % w.inel.length];
      if (Math.abs(v(a)) > 0.005 || Math.abs(v(b)) > 0.005) continue;
      const sa = s(a), sb = s(b);
      if (Math.abs(sb - sa) > 1e-6) fata.push([Math.min(sa, sb), Math.max(sa, sb)]);
    }
  }
  fata.sort((x, y) => x[0] - y[0]);
  for (let i = 0; i < fata.length;) {
    let [s0, s1] = fata[i];
    for (i++; i < fata.length && fata[i][0] <= s1 + 0.005; i++) {
      s1 = Math.max(s1, fata[i][1]);
    }
    stangi.push(s0);
    drepte.push(s1);
  }
  for (const g of plan.goluri) {
    const L = Math.hypot(g.b[0] - g.a[0], g.b[1] - g.a[1]);
    if (!(L > 0)) continue;
    const gros = grosimeaGazdei(plan, g);
    if (Math.abs(v(g.b) - v(g.a)) > 1e-3 * L) {
      const langa = Math.min(v(g.a), v(g.b));
      if (Math.abs(s(g.b) - s(g.a)) < 1e-3 * L && langa > -0.005 && langa < 0.05) {
        stangi.push(s(g.c) + gros / 2);
        drepte.push(s(g.c) - gros / 2);
      }
      continue;
    }
    if (Math.abs(v(g.c)) > gros / 2 + 0.005) continue;
    stangi.push(Math.max(s(g.a), s(g.b)));
    drepte.push(Math.min(s(g.a), s(g.b)));
  }
  return { stangi, drepte };
}

/** The nearest stops on either side of `x` along the face. */
function marginileFetei(opriri: ReturnType<typeof opririleFetei>, x: number):
    { stanga: number; dreapta: number } {
  let stanga = -Infinity;
  let dreapta = Infinity;
  for (const o of opriri.stangi) if (o <= x + 1e-6 && o > stanga) stanga = o;
  for (const o of opriri.drepte) if (o >= x - 1e-6 && o < dreapta) dreapta = o;
  return { stanga, dreapta };
}

/** The space between two chains of a face: 0.20 m, or enough for the figures
 *  of one to clear the other's when the plan is seen small. */
const pasulLanturilor = (k: number) => Math.max(0.2, (1.4 * COTA_PX.corp) / k);

/** How far into the room a face's stretch can be annotated: the near side of
 *  the wall standing across from the middle of each span, measured the same at
 *  every zoom. A wall that only reaches a span's tail is beside the room, not
 *  across it. An opening is a wall here: the room ends at a door as it does at
 *  the wall around it, and past it lies the room next door. So is a parapet. */
function zidulDinFata(plan: PlanTronson, ziduri: readonly Piedica[],
                      s: (p: Pt) => number, v: (p: Pt) => number,
                      mijloace: readonly number[]): number {
  const inFata = (t0: number, t1: number) =>
    mijloace.some((m) => Math.min(t0, t1) < m && m < Math.max(t0, t1));
  const deZid = ziduri.flatMap((z) => {
    const ts = z.pts.map(s);
    const dincolo = Math.min(...z.pts.map(v));
    return dincolo > 0.005 && inFata(Math.min(...ts), Math.max(...ts)) ? [dincolo] : [];
  });
  const deGol = plan.goluri.flatMap((g) => {
    const dincolo = v(g.c) - grosimeaGazdei(plan, g) / 2;
    return Math.abs(v(g.a) - v(g.b)) < 1e-3 && dincolo > 0.005
      && inFata(s(g.a), s(g.b)) ? [dincolo] : [];
  });
  // A balcony parapet's U-shaped ring touches the face, so only its edge
  // running along the face stands across the room.
  const deMargine = plan.pereti.flatMap((w) => w.inel.flatMap((a, i) => {
    const b = w.inel[(i + 1) % w.inel.length];
    return Math.abs(v(a) - v(b)) < 1e-3 && v(a) > 0.05 && inFata(s(a), s(b))
      ? [v(a)] : [];
  }));
  return Math.min(Infinity, ...deZid, ...deGol, ...deMargine);
}

/** Clear of the wall across: annotations stop this short of it. */
const LANGA_ZID = 0.1;

/** Where the door tags stand, for the box texts to keep off them. They are
 *  placed before anything that could move them (rule 10), on their nearest
 *  step unless the plan is crowded. */
function cutiileUsilor(plan: PlanTronson, k: number): Cutie[] {
  return plan.goluri.flatMap((g) => {
    if (g.fel !== "usa") return [];
    const c = cotaUsii(plan, g, DEPARTARI_GOL[0] / k);
    return c ? [cutiaCifrei({ ...c, corp: COTA_PX.corpGol }, k)] : [];
  });
}

/** Finds each figure of a chain a free place, in the order of rule 8: on the
 *  line at the middle, sliding along it, standing off it into the room
 *  (`Cota::deplasare`), and last past the span's ends, as CAD writes a very
 *  short dimension. A short span cannot hold its figure, and two short spans
 *  side by side would print one over the other. Nothing is dropped: a chain
 *  with a figure missing would not add up, so the least bad place wins (rule
 *  9). A figure also keeps off `linii`, every line drawn: each is painted over
 *  the figures before it, halo included. `piedici` is taken and grows
 *  with the figures placed. */
function aseazaCifrele(cote: readonly Cota[], n: Pt, k: number,
                       piedici: Cutie[], ziduri: readonly Piedica[],
                       linii: readonly Cota[] = cote): Cota[] {
  const inaltime = (COTA_PX.corp * 1.2) / k;
  const PE_LINIE = [0.5, 0.3, 0.7, 0.15, 0.85];
  return cote.map((c) => {
    const L = Math.hypot(c.b[0] - c.a[0], c.b[1] - c.a[1]);
    const dincolo = (latimeaCifrei(textulCotei(c), COTA_PX.corp) / 2
                     + 2 * COTA_PX.perna) / (k * L);
    const AFARA = [-dincolo, 1 + dincolo];
    const locuri: [number, number[]][] = [[0, PE_LINIE], [1, PE_LINIE], [0, AFARA],
                                          [1, AFARA], [2, PE_LINIE], [2, AFARA]];
    let bun = c;
    let pret = Infinity;
    cauta:
    for (const [trepte, unde] of locuri) {
      for (const la of unde) {
        const cand: Cota = {
          ...c, ...(la === 0.5 ? {} : { la }),
          ...(trepte ? { deplasare:
            [n[0] * trepte * inaltime, n[1] * trepte * inaltime] as Pt } : {}),
        };
        const cut = cutiaCifrei(cand, k);
        const tus = cutiaCifrei(cand, k, 0);
        // Ink on ink is what cannot be read; touching a neighbour's margin
        // only crowds it, and in a tiny room it may be all there is.
        const lovite = piedici.filter((q) => seAting(q, cut)).length
          + 10 * piedici.filter((q) => seAting(q, tus)).length
          + 10 * ziduri.filter((q) => seAting(q.c, tus)
              && atingePoligonul(q.pts, tus.x0, tus.x1, tus.y0, tus.y1)).length
          + linii.filter((l) => l !== c && seAting(cutiaLiniei(l, k, 1), tus)).length;
        if (lovite < pret) { bun = cand; pret = lovite; }
        if (!lovite) break cauta;
      }
    }
    piedici.push(cutiaCifrei(bun, k));
    return bun;
  });
}

/** The strip a cote's line takes on the plan: two lines closer than this read
 *  as one crooked line (rule 7). */
export function cutiaLiniei(c: Cota, k: number, px = 5): Cutie {
  const fir = px / k;
  return { x0: Math.min(c.a[0], c.b[0]) - fir, x1: Math.max(c.a[0], c.b[0]) + fir,
           y0: Math.min(c.a[1], c.b[1]) - fir, y1: Math.max(c.a[1], c.b[1]) + fir };
}

/** The boxes whose «H=» reads better at the right end of the row: at the
 *  left, its usual place, it would fall under a door tag or a room name. */
export function dozeleCuEtichetaLaDreapta(plan: PlanTronson, k: number,
                                          ocupate: readonly Cutie[]): Set<number> {
  const out = new Set<number>();
  if (!(k > 0)) return out;
  const piedici = [...ocupate, ...cutiileUsilor(plan, k)];
  const ziduri = piedicile(plan).filter((q) => q.zid);
  // Every obstacle counts, not every label: a plan cote's line crosses both
  // ends of a row alike, and only its figure tells the sides apart. A wall
  // weighs most: a label on hatching cannot be read at all, and a box 15 cm
  // from a corner, the guide's own place, has one right beside its row.
  const lovite = (cutii: readonly Cutie[]) => cutii.reduce((sum, c) =>
    sum + piedici.filter((q) => seAting(q, c)).length
    + 10 * ziduri.filter((q) => seAting(q.c, c)
        && atingePoligonul(q.pts, c.x0, c.x1, c.y0, c.y1)).length, 0);
  for (const u of grupeleDozelor(plan.electrice)) {
    const stanga = cutiileEtichetelorH(u, k, false);
    const dreapta = cutiileEtichetelorH(u, k, true);
    const mutat = lovite(stanga) > lovite(dreapta);
    if (mutat) out.add(u[0].idx);
    // Each label placed is one the next box's must keep off.
    piedici.push(...(mutat ? dreapta : stanga));
  }
  return out;
}

/** THE BOXES' CHAINS (the architect's 1.2–1.4): per wall face, height and
 *  family, wall face → axis₁ → … → axisₙ → jamb or wall face. The measure is
 *  the office guide's own (axis to the door frame, axis to the corner), so
 *  the chain is permanent, not a selection aid. Empty boxes, boxes off every
 *  wall and oblique hosts make none. `pxPerM` only places the drawn line
 *  beyond the device rows and the figures on it; the measured spans are
 *  geometry. `ocupate` is what the chains must keep off: the room names and
 *  the plan's own figures. */
export function coteleDozelor(plan: PlanTronson, pxPerM: number,
                              ocupate: readonly Cutie[] = []): LantDoza[] {
  type Fata = { axa: 0 | 1; u: Pt; n: Pt; baza: Pt;
                doze: typeof plan.electrice };
  const fete: Fata[] = [];
  for (const e of plan.electrice) {
    if (e.kind !== "doza" || !(e.devices ?? []).length) continue;
    if (!gazdaDozei(plan, e)) continue;
    const rad = (e.deg * Math.PI) / 180;
    const n: Pt = [Math.cos(rad), Math.sin(rad)];
    // Only axis-aligned hosts (the plan's own cotes have the same limit).
    const axa: 0 | 1 | null = Math.abs(n[1]) > 1 - 1e-6 ? 0
      : Math.abs(n[0]) > 1 - 1e-6 ? 1 : null;
    if (axa == null) continue;
    const u: Pt = axa === 0 ? [1, 0] : [0, 1];
    // One face = one line and one normal sign: the two faces of a wall are
    // dimensioned apart, since each belongs to another room, and a face
    // that runs over several wall segments is one.
    const fata = fete.find((f) => f.n[0] * n[0] + f.n[1] * n[1] > 0.5
      && Math.abs((e.c[0] - f.baza[0]) * f.n[0] + (e.c[1] - f.baza[1]) * f.n[1]) <= 0.005);
    if (fata) fata.doze.push(e);
    else fete.push({ axa, u, n, baza: e.c, doze: [e] });
  }

  const out: LantDoza[] = [];
  if (!fete.length) return out;
  const piedici = [...ocupate, ...cutiileUsilor(plan, pxPerM)];
  const ziduri = piedicile(plan).filter((q) => q.zid);
  const pas = pasulLanturilor(pxPerM);
  // Across faces too: the chains of a room's opposite walls share its middle.
  const liniiPuse: Cutie[] = [];
  const schiteToate: { n: Pt; fam: FamilieDoza; h: number; cote: Cota[] }[] = [];
  const prag = 20 / pxPerM;
  for (const f of fete) {
    const s = (p: Pt) => (p[0] - f.baza[0]) * f.u[0] + (p[1] - f.baza[1]) * f.u[1];
    const v = (p: Pt) => (p[0] - f.baza[0]) * f.n[0] + (p[1] - f.baza[1]) * f.n[1];
    const pe = (ss: number, vv: number): Pt =>
      [f.baza[0] + f.u[0] * ss + f.n[0] * vv,
       f.baza[1] + f.u[1] * ss + f.n[1] * vv];

    // The chains of one face stack by height, then family, beyond the rows of
    // every glyph on the face (R8): the first line 0.10 m past them, each
    // next 0.20 m further.
    const inaltimi = [...new Set(f.doze.map((e) => e.h))];
    const randuri = Math.max(
      ...grupeleDozelor(f.doze).map((u) => intindereaDozei(u, pxPerM)), 0);
    const lanturi: { fam: FamilieDoza; h: number; axe: number[] }[] = [];
    for (const h of inaltimi) {
      for (const fam of ["prize", "comenzi"] as const) {
        const axe = f.doze
          .filter((e) => e.h === h && familiileDozei(e.devices ?? []).includes(fam))
          .map((e) => s(e.c))
          .sort((a, b) => a - b);
        if (axe.length) lanturi.push({ fam, h, axe });
      }
    }
    lanturi.sort((a, b) => (a.h - b.h) || (a.fam === b.fam ? 0
      : a.fam === "prize" ? -1 : 1));

    const opriri = opririleFetei(plan, s, v);
    const peLinie = (intinderi: readonly (readonly [number, number])[], vv: number,
                     de: readonly Cutie[]) => de.some((o) => {
      const col: Pt[] = [[o.x0, o.y0], [o.x1, o.y1]];
      const ts = col.map(s), vs = col.map(v);
      return intinderi.some(([m0, m1]) =>
        Math.min(Math.max(...ts), m1) - Math.max(Math.min(...ts), m0) > prag)
        && Math.min(...vs) <= vv && vv <= Math.max(...vs);
    });
    let vLinie = randuri + 0.1 - pas;
    const vMin = randuri + 0.1;
    const peFata: { fam: FamilieDoza; h: number; v: number; limita: number;
                    intinderi: [number, number][] }[] = [];
    for (const lant of lanturi) {
      // A chain runs from stop to stop: boxes with a door, a passage or a
      // wall between them are dimensioned each from its own side of it, and
      // no span crosses the doorway (the architect's own layout: the switch
      // on one side of the door, the socket on the other).
      const intinderi: [number, number][] = [];
      const leaga = (m0: number, m1: number) => {
        if (!Number.isFinite(m0) || !Number.isFinite(m1) || m1 - m0 <= 0.005) return;
        intinderi.push([m0, m1]);
      };
      lant.axe.forEach((x, i) => {
        const { stanga, dreapta } = marginileFetei(opriri, x);
        const inainte = i > 0 ? lant.axe[i - 1] : -Infinity;
        const dupa = i + 1 < lant.axe.length ? lant.axe[i + 1] : Infinity;
        if (inainte < stanga) leaga(stanga, x);
        leaga(x, Math.min(dreapta, dupa));
      });
      vLinie += pas;
      if (!intinderi.length) continue;
      // The line steps clear of what it would run along: a figure can slide
      // off a room name, a line cannot. Something the line only crosses, a
      // perpendicular cote, is no reason to move, and stepping could never
      // clear it anyway.
      const limita = zidulDinFata(plan, ziduri, s, v,
                                  intinderi.map(([m0, m1]) => (m0 + m1) / 2)) - LANGA_ZID;
      const treapta = Math.max(0.1, 10 / pxPerM);
      const trepte = [0, 1, 2, 3, 4, 5].map((t) => vLinie + t * treapta)
        .filter((vv) => vv <= limita);
      // Short of a free step, a line through a name beats a line on a chain:
      // a figure can slide off the name, two chains would read as one.
      const liber = trepte.find((vv) => !peLinie(intinderi, vv, [...ocupate, ...liniiPuse]))
        ?? trepte.find((vv) => !peLinie(intinderi, vv, liniiPuse));
      if (liber != null) vLinie = liber;
      peFata.push({ fam: lant.fam, h: lant.h, v: vLinie, limita, intinderi });
    }
    // Stacked past the room, a chain would dimension the room next door. The
    // chains that share the stretch are spaced again to fit, never below what
    // tells two lines apart: on one line, one would hide the other.
    const minim = 12 / pxPerM;
    const seSuprapun = (x: typeof peFata[number], y: typeof peFata[number]) =>
      x.intinderi.some(([a0, a1]) => y.intinderi.some(([b0, b1]) =>
        Math.min(a1, b1) > Math.max(a0, b0)));
    for (const l of [...peFata].reverse()) {
      if (l.v <= l.limita) continue;
      // The whole connected group: A over B and B over C share one stack even
      // where A and C do not, and only part of it would land B on A.
      const grup = [l];
      for (let i = 0; i < grup.length; i++) {
        for (const o of peFata) {
          if (!grup.includes(o) && seSuprapun(o, grup[i])) grup.push(o);
        }
      }
      grup.sort((x, y) => peFata.indexOf(x) - peFata.indexOf(y));
      const strans = grup.length > 1 ? (l.limita - vMin) / (grup.length - 1) : 0;
      grup.forEach((o, i) => {
        o.v = Math.min(o.v, vMin + i * Math.max(strans, minim));
      });
    }
    // The spacing can undo a step off the opposite wall's line: such a line
    // takes the nearest clear place between its neighbours, keeping their order.
    for (const l of [...peFata].sort((x, y) => x.v - y.v)) {
      if (!peLinie(l.intinderi, l.v, liniiPuse)) continue;
      const vecini = peFata.filter((o) => o !== l && seSuprapun(o, l)).map((o) => o.v);
      const jos = Math.max(vMin, ...vecini.filter((w) => w < l.v).map((w) => w + minim));
      const sus = Math.min(l.limita, ...vecini.filter((w) => w > l.v).map((w) => w - minim));
      const loc = Array.from({ length: Math.ceil((sus - jos) * pxPerM) * 2 + 1 }, (_, t) =>
        l.v + ((t + 1) >> 1) * (t % 2 ? 1 : -1) / pxPerM)
        .find((vv) => vv >= jos && vv <= sus && !peLinie(l.intinderi, vv, liniiPuse));
      if (loc != null) l.v = loc;
    }
    const schite = peFata.map((l) => ({
      fam: l.fam, h: l.h,
      cote: l.intinderi.map(([m0, m1]): Cota => ({
        a: pe(m0, l.v), b: pe(m1, l.v), valoare: m1 - m0,
        masurat: [pe(m0, 0), pe(m1, 0)],
      })),
    }));
    schiteToate.push(...schite.map((l) => ({ ...l, n: f.n })));
    liniiPuse.push(...schite.flatMap((l) => l.cote.map((c) => cutiaLiniei(c, pxPerM, 6))));
  }
  // The figures come last: they must see every line, the later chains' and the
  // opposite wall's too.
  const linii = schiteToate.flatMap((l) => l.cote);
  return schiteToate.map(({ n, ...l }) => (
    { ...l, cote: aseazaCifrele(l.cote, n, pxPerM, piedici, ziduri, linii) }));
}

/** The selected box's editable cotes (the blue ones): its axis to the nearest
 *  mark on each side — a chain bound, or the axis of another box with devices
 *  at its height that shares a family with it (an empty box takes any). Typed,
 *  they move the box along the wall; `null` when the box has no axis-aligned
 *  host, and the caller falls back to the four-direction scan. */
function coteleDozeiAlese(plan: PlanTronson, e: PlanTronson["electrice"][number],
                          pxPerM?: number, desenate?: readonly LantDoza[]):
    Cota[] | null {
  const host = gazdaDozei(plan, e);
  if (!host) return null;
  const rad = (e.deg * Math.PI) / 180;
  const n: Pt = [Math.cos(rad), Math.sin(rad)];
  const axa: 0 | 1 | null = Math.abs(n[1]) > 1 - 1e-6 ? 0
    : Math.abs(n[0]) > 1 - 1e-6 ? 1 : null;
  if (axa == null) return null;
  const u: Pt = axa === 0 ? [1, 0] : [0, 1];
  const s = (p: Pt) => (p[0] - e.c[0]) * u[0] + (p[1] - e.c[1]) * u[1];
  const v = (p: Pt) => (p[0] - e.c[0]) * n[0] + (p[1] - e.c[1]) * n[1];
  const pe = (ss: number, vv: number): Pt =>
    [e.c[0] + u[0] * ss + n[0] * vv, e.c[1] + u[1] * ss + n[1] * vv];

  const ale = familiileDozei(e.devices ?? []);
  const marci: number[] = [];
  for (const alt of plan.electrice) {
    if (alt.idx === e.idx || alt.kind !== "doza" || !(alt.devices ?? []).length) continue;
    if (Math.abs(alt.h - e.h) > 1e-6) continue;
    // On the same face line, facing the same room, whichever segment hosts it.
    const radAlt = (alt.deg * Math.PI) / 180;
    if (Math.cos(radAlt) * n[0] + Math.sin(radAlt) * n[1] <= 0.5) continue;
    if (Math.abs(v(alt.c)) > 0.005 || !gazdaDozei(plan, alt)) continue;
    const fam = familiileDozei(alt.devices ?? []);
    if (ale.length && !fam.some((x) => ale.includes(x))) continue;
    marci.push(s(alt.c));
  }
  const { stanga, dreapta } = marginileFetei(opririleFetei(plan, s, v), 0);
  const laStanga = Math.max(stanga, ...marci.filter((m) => m < -1e-6));
  const laDreapta = Math.min(dreapta, ...marci.filter((m) => m > 1e-6));

  // On a line of their own past the face's rows and chains, which they would
  // otherwise run through: past the chains as drawn, which `Desen` has placed
  // around the plan's text, and past their figures, which may stand off them.
  const lanturi = desenate ?? (pxPerM ? coteleDozelor(plan, pxPerM) : []);
  const toate = lanturi.flatMap((l) => l.cote);
  const peFata = toate.filter((c) =>
    Math.abs(v(c.masurat![0])) <= 0.005 && v(c.a) > 0);
  const ziduri = piedicile(plan).filter((q) => q.zid);
  // Past every glyph of the face, not only this one: the chains clear them all.
  const vRanduri = pxPerM
    ? 0.1 + Math.max(...grupeleDozelor(plan.electrice)
      .filter((u2) => Math.abs(v(u2[0].c)) <= 0.005
                      && Math.cos(((u2[0].deg - e.deg) * Math.PI) / 180) > 0.5)
      .map((u2) => intindereaDozei(u2, pxPerM)), 0)
    : 0.15;
  let vAlbastru = vRanduri;
  if (pxPerM) {
    const dorit = Math.max(vRanduri, ...peFata.map(
      (c) => v(punctulCifrei(c)) + pasulLanturilor(pxPerM)));
    const mijloace = [laStanga / 2, laDreapta / 2].filter(Number.isFinite);
    const limita = zidulDinFata(plan, ziduri, s, v, mijloace) - LANGA_ZID;
    // Off every line along its stretch, the facing wall's chains too: back
    // towards the box from past the face's chains, or from the wall across, and
    // if nothing is wide enough the widest gap there is. A blue line in the
    // next room would measure nothing the eye can tie to this box, and one on a
    // chain would hide it.
    const pas = 12 / pxPerM;
    const linii = toate
      .filter((c) => Math.abs(v(c.a) - v(c.b)) < 1e-6 && v(c.a) > 0
        && Math.min(Math.max(s(c.a), s(c.b)), laDreapta)
           > Math.max(Math.min(s(c.a), s(c.b)), laStanga))
      .map((c) => v(c.a));
    const pornire = Math.max(vRanduri, Math.min(dorit, limita));
    vAlbastru = pornire;
    let cel = -1;
    for (let vv = pornire; vv >= vRanduri; vv -= pas / 4) {
      const langa = Math.min(Infinity, ...linii.map((l) => Math.abs(l - vv)));
      if (langa > cel) { cel = langa; vAlbastru = vv; }
      if (langa >= pas) break;
    }
  }

  // Which way the figure moves the box: `scrieCota` sends semn × (valoare −
  // scris) down the measured axis, as the door-placement cotes do.
  const comp = u[axa];
  const out: Cota[] = [];
  // The chain's own threshold: a side with nothing to measure, a box on a
  // jamb, carries no figure, in the chain or here.
  if (Number.isFinite(laStanga) && -laStanga > 0.005) {
    out.push({ a: pe(laStanga, vAlbastru), b: pe(0, vAlbastru), valoare: -laStanga,
               masurat: [pe(laStanga, 0), pe(0, 0)],
               muta: { axa, semn: (comp > 0 ? -1 : 1) as 1 | -1 } });
  }
  if (Number.isFinite(laDreapta) && laDreapta > 0.005) {
    out.push({ a: pe(0, vAlbastru), b: pe(laDreapta, vAlbastru), valoare: laDreapta,
               masurat: [pe(0, 0), pe(laDreapta, 0)],
               muta: { axa, semn: (comp > 0 ? 1 : -1) as 1 | -1 } });
  }
  return pxPerM
    ? aseazaCifrele(out, n, pxPerM, toate.map((c) => cutiaCifrei(c, pxPerM)),
                    ziduri, [...out, ...toate])
    : out;
}

/** The host wall's thickness per box, for the drawn depth cap: a floored box
 *  widens on screen, but it must never poke through its own wall. */
export function grosimileDozelor(plan: PlanTronson): Map<number, number> {
  const out = new Map<number, number>();
  for (const e of plan.electrice) {
    if (e.kind !== "doza") continue;
    const g = gazdaDozei(plan, e);
    if (g) out.set(e.idx, g.grosime);
  }
  return out;
}

/** Pentru teste: camera e a inelului? */
export const _inInel = (p: Pt, c: Camera) => inInel(p, c.inel);
